window.DIPLauncherWidget = function (e) {
  var n = {};

  function t(a) {
    if (n[a]) return n[a].exports;
    var o = n[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, a) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: a
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (t.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var o in e) {
      t.d(a, o, function (n) {
        return e[n];
      }.bind(null, o));
    }
    return a;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "/", t(t.s = 19);
}([function (e, n, t) {
  "use strict";

  t.r(n);
  var a,
      o,
      r,
      l,
      i,
      c,
      s,
      u = {},
      p = [],
      d = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

  function f(e, n) {
    for (var t in n) {
      e[t] = n[t];
    }

    return e;
  }

  function m(e) {
    var n = e.parentNode;
    n && n.removeChild(e);
  }

  function h(e, n, t) {
    var a,
        o = arguments,
        r = {};

    for (a in n) {
      "key" !== a && "ref" !== a && (r[a] = n[a]);
    }

    if (arguments.length > 3) for (t = [t], a = 3; a < arguments.length; a++) {
      t.push(o[a]);
    }
    if (null != t && (r.children = t), "function" == typeof e && null != e.defaultProps) for (a in e.defaultProps) {
      void 0 === r[a] && (r[a] = e.defaultProps[a]);
    }
    return _(e, r, n && n.key, n && n.ref, null);
  }

  function _(e, n, t, o, r) {
    var l = {
      type: e,
      props: n,
      key: t,
      ref: o,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __d: void 0,
      __c: null,
      constructor: void 0,
      __v: r
    };
    return null == r && (l.__v = l), a.vnode && a.vnode(l), l;
  }

  function v() {
    return {};
  }

  function g(e) {
    return e.children;
  }

  function y(e, n) {
    this.props = e, this.context = n;
  }

  function b(e, n) {
    if (null == n) return e.__ ? b(e.__, e.__.__k.indexOf(e) + 1) : null;

    for (var t; n < e.__k.length; n++) {
      if (null != (t = e.__k[n]) && null != t.__e) return t.__e;
    }

    return "function" == typeof e.type ? b(e) : null;
  }

  function C(e) {
    var n, t;

    if (null != (e = e.__) && null != e.__c) {
      for (e.__e = e.__c.base = null, n = 0; n < e.__k.length; n++) {
        if (null != (t = e.__k[n]) && null != t.__e) {
          e.__e = e.__c.base = t.__e;
          break;
        }
      }

      return C(e);
    }
  }

  function L(e) {
    (!e.__d && (e.__d = !0) && o.push(e) && !r++ || i !== a.debounceRendering) && ((i = a.debounceRendering) || l)(k);
  }

  function k() {
    for (var e; r = o.length;) {
      e = o.sort(function (e, n) {
        return e.__v.__b - n.__v.__b;
      }), o = [], e.some(function (e) {
        var n, t, a, o, r, l, i;
        e.__d && (l = (r = (n = e).__v).__e, (i = n.__P) && (t = [], (a = f({}, r)).__v = a, o = T(i, r, a, n.__n, void 0 !== i.ownerSVGElement, null, t, null == l ? b(r) : l), A(t, r), o != l && C(r)));
      });
    }
  }

  function x(e, n, t, a, o, r, l, i, c) {
    var s,
        d,
        f,
        h,
        _,
        v,
        g,
        y = t && t.__k || p,
        C = y.length;

    if (i == u && (i = null != r ? r[0] : C ? b(t, 0) : null), s = 0, n.__k = w(n.__k, function (t) {
      if (null != t) {
        if (t.__ = n, t.__b = n.__b + 1, null === (f = y[s]) || f && t.key == f.key && t.type === f.type) y[s] = void 0;else for (d = 0; d < C; d++) {
          if ((f = y[d]) && t.key == f.key && t.type === f.type) {
            y[d] = void 0;
            break;
          }

          f = null;
        }

        if (h = T(e, t, f = f || u, a, o, r, l, i, c), (d = t.ref) && f.ref != d && (g || (g = []), f.ref && g.push(f.ref, null, t), g.push(d, t.__c || h, t)), null != h) {
          var p;
          if (null == v && (v = h), void 0 !== t.__d) p = t.__d, t.__d = void 0;else if (r == f || h != i || null == h.parentNode) {
            e: if (null == i || i.parentNode !== e) e.appendChild(h), p = null;else {
              for (_ = i, d = 0; (_ = _.nextSibling) && d < C; d += 2) {
                if (_ == h) break e;
              }

              e.insertBefore(h, i), p = i;
            }

            "option" == n.type && (e.value = "");
          }
          i = void 0 !== p ? p : h.nextSibling, "function" == typeof n.type && (n.__d = i);
        } else i && f.__e == i && i.parentNode != e && (i = b(f));
      }

      return s++, t;
    }), n.__e = v, null != r && "function" != typeof n.type) for (s = r.length; s--;) {
      null != r[s] && m(r[s]);
    }

    for (s = C; s--;) {
      null != y[s] && O(y[s], y[s]);
    }

    if (g) for (s = 0; s < g.length; s++) {
      I(g[s], g[++s], g[++s]);
    }
  }

  function w(e, n, t) {
    if (null == t && (t = []), null == e || "boolean" == typeof e) n && t.push(n(null));else if (Array.isArray(e)) for (var a = 0; a < e.length; a++) {
      w(e[a], n, t);
    } else t.push(n ? n("string" == typeof e || "number" == typeof e ? _(null, e, null, null, e) : null != e.__e || null != e.__c ? _(e.type, e.props, e.key, null, e.__v) : e) : e);
    return t;
  }

  function S(e, n, t) {
    "-" === n[0] ? e.setProperty(n, t) : e[n] = "number" == typeof t && !1 === d.test(n) ? t + "px" : null == t ? "" : t;
  }

  function M(e, n, t, a, o) {
    var r, l, i, c, s;
    if (o ? "className" === n && (n = "class") : "class" === n && (n = "className"), "style" === n) {
      if (r = e.style, "string" == typeof t) r.cssText = t;else {
        if ("string" == typeof a && (r.cssText = "", a = null), a) for (c in a) {
          t && c in t || S(r, c, "");
        }
        if (t) for (s in t) {
          a && t[s] === a[s] || S(r, s, t[s]);
        }
      }
    } else "o" === n[0] && "n" === n[1] ? (l = n !== (n = n.replace(/Capture$/, "")), i = n.toLowerCase(), n = (i in e ? i : n).slice(2), t ? (a || e.addEventListener(n, E, l), (e.l || (e.l = {}))[n] = t) : e.removeEventListener(n, E, l)) : "list" !== n && "tagName" !== n && "form" !== n && "type" !== n && "size" !== n && !o && n in e ? e[n] = null == t ? "" : t : "function" != typeof t && "dangerouslySetInnerHTML" !== n && (n !== (n = n.replace(/^xlink:?/, "")) ? null == t || !1 === t ? e.removeAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase()) : e.setAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase(), t) : null == t || !1 === t && !/^ar/.test(n) ? e.removeAttribute(n) : e.setAttribute(n, t));
  }

  function E(e) {
    this.l[e.type](a.event ? a.event(e) : e);
  }

  function T(e, n, t, o, r, l, i, c, s) {
    var u,
        p,
        d,
        m,
        h,
        _,
        v,
        b,
        C,
        L,
        k = n.type;

    if (void 0 !== n.constructor) return null;
    (u = a.__b) && u(n);

    try {
      e: if ("function" == typeof k) {
        if (b = n.props, C = (u = k.contextType) && o[u.__c], L = u ? C ? C.props.value : u.__ : o, t.__c ? v = (p = n.__c = t.__c).__ = p.__E : ("prototype" in k && k.prototype.render ? n.__c = p = new k(b, L) : (n.__c = p = new y(b, L), p.constructor = k, p.render = H), C && C.sub(p), p.props = b, p.state || (p.state = {}), p.context = L, p.__n = o, d = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != k.getDerivedStateFromProps && (p.__s == p.state && (p.__s = f({}, p.__s)), f(p.__s, k.getDerivedStateFromProps(b, p.__s))), m = p.props, h = p.state, d) null == k.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
          if (null == k.getDerivedStateFromProps && b !== m && null != p.componentWillReceiveProps && p.componentWillReceiveProps(b, L), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(b, p.__s, L) || n.__v === t.__v && !p.__) {
            for (p.props = b, p.state = p.__s, n.__v !== t.__v && (p.__d = !1), p.__v = n, n.__e = t.__e, n.__k = t.__k, p.__h.length && i.push(p), u = 0; u < n.__k.length; u++) {
              n.__k[u] && (n.__k[u].__ = n);
            }

            break e;
          }

          null != p.componentWillUpdate && p.componentWillUpdate(b, p.__s, L), null != p.componentDidUpdate && p.__h.push(function () {
            p.componentDidUpdate(m, h, _);
          });
        }
        p.context = L, p.props = b, p.state = p.__s, (u = a.__r) && u(n), p.__d = !1, p.__v = n, p.__P = e, u = p.render(p.props, p.state, p.context), n.__k = null != u && u.type == g && null == u.key ? u.props.children : Array.isArray(u) ? u : [u], null != p.getChildContext && (o = f(f({}, o), p.getChildContext())), d || null == p.getSnapshotBeforeUpdate || (_ = p.getSnapshotBeforeUpdate(m, h)), x(e, n, t, o, r, l, i, c, s), p.base = n.__e, p.__h.length && i.push(p), v && (p.__E = p.__ = null), p.__e = !1;
      } else null == l && n.__v === t.__v ? (n.__k = t.__k, n.__e = t.__e) : n.__e = N(t.__e, n, t, o, r, l, i, s);

      (u = a.diffed) && u(n);
    } catch (e) {
      n.__v = null, a.__e(e, n, t);
    }

    return n.__e;
  }

  function A(e, n) {
    a.__c && a.__c(n, e), e.some(function (n) {
      try {
        e = n.__h, n.__h = [], e.some(function (e) {
          e.call(n);
        });
      } catch (e) {
        a.__e(e, n.__v);
      }
    });
  }

  function N(e, n, t, a, o, r, l, i) {
    var c,
        s,
        d,
        f,
        m,
        h = t.props,
        _ = n.props;
    if (o = "svg" === n.type || o, null != r) for (c = 0; c < r.length; c++) {
      if (null != (s = r[c]) && ((null === n.type ? 3 === s.nodeType : s.localName === n.type) || e == s)) {
        e = s, r[c] = null;
        break;
      }
    }

    if (null == e) {
      if (null === n.type) return document.createTextNode(_);
      e = o ? document.createElementNS("http://www.w3.org/2000/svg", n.type) : document.createElement(n.type, _.is && {
        is: _.is
      }), r = null, i = !1;
    }

    if (null === n.type) h !== _ && e.data != _ && (e.data = _);else {
      if (null != r && (r = p.slice.call(e.childNodes)), d = (h = t.props || u).dangerouslySetInnerHTML, f = _.dangerouslySetInnerHTML, !i) {
        if (h === u) for (h = {}, m = 0; m < e.attributes.length; m++) {
          h[e.attributes[m].name] = e.attributes[m].value;
        }
        (f || d) && (f && d && f.__html == d.__html || (e.innerHTML = f && f.__html || ""));
      }

      (function (e, n, t, a, o) {
        var r;

        for (r in t) {
          "children" === r || "key" === r || r in n || M(e, r, null, t[r], a);
        }

        for (r in n) {
          o && "function" != typeof n[r] || "children" === r || "key" === r || "value" === r || "checked" === r || t[r] === n[r] || M(e, r, n[r], t[r], a);
        }
      })(e, _, h, o, i), f ? n.__k = [] : (n.__k = n.props.children, x(e, n, t, a, "foreignObject" !== n.type && o, r, l, u, i)), i || ("value" in _ && void 0 !== (c = _.value) && c !== e.value && M(e, "value", c, h.value, !1), "checked" in _ && void 0 !== (c = _.checked) && c !== e.checked && M(e, "checked", c, h.checked, !1));
    }
    return e;
  }

  function I(e, n, t) {
    try {
      "function" == typeof e ? e(n) : e.current = n;
    } catch (e) {
      a.__e(e, t);
    }
  }

  function O(e, n, t) {
    var o, r, l;

    if (a.unmount && a.unmount(e), (o = e.ref) && (o.current && o.current !== e.__e || I(o, null, n)), t || "function" == typeof e.type || (t = null != (r = e.__e)), e.__e = e.__d = void 0, null != (o = e.__c)) {
      if (o.componentWillUnmount) try {
        o.componentWillUnmount();
      } catch (e) {
        a.__e(e, n);
      }
      o.base = o.__P = null;
    }

    if (o = e.__k) for (l = 0; l < o.length; l++) {
      o[l] && O(o[l], n, t);
    }
    null != r && m(r);
  }

  function H(e, n, t) {
    return this.constructor(e, t);
  }

  function P(e, n, t) {
    var o, r, l;
    a.__ && a.__(e, n), r = (o = t === c) ? null : t && t.__k || n.__k, e = h(g, null, [e]), l = [], T(n, (o ? n : t || n).__k = e, r || u, u, void 0 !== n.ownerSVGElement, t && !o ? [t] : r ? null : p.slice.call(n.childNodes), l, t || u, o), A(l, e);
  }

  function Z(e, n) {
    P(e, n, c);
  }

  function D(e, n) {
    var t, a;

    for (a in n = f(f({}, e.props), n), arguments.length > 2 && (n.children = p.slice.call(arguments, 2)), t = {}, n) {
      "key" !== a && "ref" !== a && (t[a] = n[a]);
    }

    return _(e.type, t, n.key || e.key, n.ref || e.ref, null);
  }

  function U(e) {
    var n = {},
        t = {
      __c: "__cC" + s++,
      __: e,
      Consumer: function Consumer(e, n) {
        return e.children(n);
      },
      Provider: function Provider(e) {
        var a,
            o = this;
        return this.getChildContext || (a = [], this.getChildContext = function () {
          return n[t.__c] = o, n;
        }, this.shouldComponentUpdate = function (e) {
          o.props.value !== e.value && a.some(function (n) {
            n.context = e.value, L(n);
          });
        }, this.sub = function (e) {
          a.push(e);
          var n = e.componentWillUnmount;

          e.componentWillUnmount = function () {
            a.splice(a.indexOf(e), 1), n && n.call(e);
          };
        }), e.children;
      }
    };
    return t.Consumer.contextType = t, t.Provider.__ = t, t;
  }

  a = {
    __e: function __e(e, n) {
      for (var t, a; n = n.__;) {
        if ((t = n.__c) && !t.__) try {
          if (t.constructor && null != t.constructor.getDerivedStateFromError && (a = !0, t.setState(t.constructor.getDerivedStateFromError(e))), null != t.componentDidCatch && (a = !0, t.componentDidCatch(e)), a) return L(t.__E = t);
        } catch (n) {
          e = n;
        }
      }

      throw e;
    }
  }, y.prototype.setState = function (e, n) {
    var t;
    t = this.__s !== this.state ? this.__s : this.__s = f({}, this.state), "function" == typeof e && (e = e(t, this.props)), e && f(t, e), null != e && this.__v && (n && this.__h.push(n), L(this));
  }, y.prototype.forceUpdate = function (e) {
    this.__v && (this.__e = !0, e && this.__h.push(e), L(this));
  }, y.prototype.render = g, o = [], r = 0, l = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, c = u, s = 0;
  var R,
      V,
      z,
      F = 0,
      q = [],
      G = a.__r,
      j = a.diffed,
      B = a.__c,
      W = a.unmount;

  function X(e, n) {
    a.__h && a.__h(V, e, F || n), F = 0;
    var t = V.__H || (V.__H = {
      __: [],
      __h: []
    });
    return e >= t.__.length && t.__.push({}), t.__[e];
  }

  function Y(e) {
    return F = 1, K(ue, e);
  }

  function K(e, n, t) {
    var a = X(R++, 2);
    return a.__c || (a.__c = V, a.__ = [t ? t(n) : ue(void 0, n), function (n) {
      var t = e(a.__[0], n);
      a.__[0] !== t && (a.__[0] = t, a.__c.setState({}));
    }]), a.__;
  }

  function $(e, n) {
    var t = X(R++, 3);
    !a.__s && se(t.__H, n) && (t.__ = e, t.__H = n, V.__H.__h.push(t));
  }

  function J(e, n) {
    var t = X(R++, 4);
    !a.__s && se(t.__H, n) && (t.__ = e, t.__H = n, V.__h.push(t));
  }

  function Q(e) {
    return F = 5, ne(function () {
      return {
        current: e
      };
    }, []);
  }

  function ee(e, n, t) {
    F = 6, J(function () {
      "function" == typeof e ? e(n()) : e && (e.current = n());
    }, null == t ? t : t.concat(e));
  }

  function ne(e, n) {
    var t = X(R++, 7);
    return se(t.__H, n) ? (t.__H = n, t.__h = e, t.__ = e()) : t.__;
  }

  function te(e, n) {
    return F = 8, ne(function () {
      return e;
    }, n);
  }

  function ae(e) {
    var n = V.context[e.__c],
        t = X(R++, 9);
    return t.__c = e, n ? (null == t.__ && (t.__ = !0, n.sub(V)), n.props.value) : e.__;
  }

  function oe(e, n) {
    a.useDebugValue && a.useDebugValue(n ? n(e) : e);
  }

  function re(e) {
    var n = X(R++, 10),
        t = Y();
    return n.__ = e, V.componentDidCatch || (V.componentDidCatch = function (e) {
      n.__ && n.__(e), t[1](e);
    }), [t[0], function () {
      t[1](void 0);
    }];
  }

  function le() {
    q.some(function (e) {
      if (e.__P) try {
        e.__H.__h.forEach(ie), e.__H.__h.forEach(ce), e.__H.__h = [];
      } catch (n) {
        return e.__H.__h = [], a.__e(n, e.__v), !0;
      }
    }), q = [];
  }

  function ie(e) {
    e.t && e.t();
  }

  function ce(e) {
    var n = e.__();

    "function" == typeof n && (e.t = n);
  }

  function se(e, n) {
    return !e || n.some(function (n, t) {
      return n !== e[t];
    });
  }

  function ue(e, n) {
    return "function" == typeof n ? n(e) : n;
  }

  function pe(e, n) {
    for (var t in n) {
      e[t] = n[t];
    }

    return e;
  }

  function de(e, n) {
    for (var t in e) {
      if ("__source" !== t && !(t in n)) return !0;
    }

    for (var a in n) {
      if ("__source" !== a && e[a] !== n[a]) return !0;
    }

    return !1;
  }

  a.__r = function (e) {
    G && G(e), R = 0, (V = e.__c).__H && (V.__H.__h.forEach(ie), V.__H.__h.forEach(ce), V.__H.__h = []);
  }, a.diffed = function (e) {
    j && j(e);
    var n = e.__c;

    if (n) {
      var t = n.__H;
      t && t.__h.length && (1 !== q.push(n) && z === a.requestAnimationFrame || ((z = a.requestAnimationFrame) || function (e) {
        var n,
            t = function t() {
          clearTimeout(a), cancelAnimationFrame(n), setTimeout(e);
        },
            a = setTimeout(t, 100);

        "undefined" != typeof window && (n = requestAnimationFrame(t));
      })(le));
    }
  }, a.__c = function (e, n) {
    n.some(function (e) {
      try {
        e.__h.forEach(ie), e.__h = e.__h.filter(function (e) {
          return !e.__ || ce(e);
        });
      } catch (t) {
        n.some(function (e) {
          e.__h && (e.__h = []);
        }), n = [], a.__e(t, e.__v);
      }
    }), B && B(e, n);
  }, a.unmount = function (e) {
    W && W(e);
    var n = e.__c;

    if (n) {
      var t = n.__H;
      if (t) try {
        t.__.forEach(function (e) {
          return e.t && e.t();
        });
      } catch (e) {
        a.__e(e, n.__v);
      }
    }
  }, t.d(n, "version", function () {
    return De;
  }), t.d(n, "Children", function () {
    return ge;
  }), t.d(n, "render", function () {
    return Ne;
  }), t.d(n, "hydrate", function () {
    return Ie;
  }), t.d(n, "unmountComponentAtNode", function () {
    return ze;
  }), t.d(n, "createPortal", function () {
    return Ee;
  }), t.d(n, "createFactory", function () {
    return Ue;
  }), t.d(n, "cloneElement", function () {
    return Ve;
  }), t.d(n, "isValidElement", function () {
    return Re;
  }), t.d(n, "findDOMNode", function () {
    return Fe;
  }), t.d(n, "PureComponent", function () {
    return fe;
  }), t.d(n, "memo", function () {
    return me;
  }), t.d(n, "forwardRef", function () {
    return _e;
  }), t.d(n, "unstable_batchedUpdates", function () {
    return qe;
  }), t.d(n, "Suspense", function () {
    return Ce;
  }), t.d(n, "SuspenseList", function () {
    return xe;
  }), t.d(n, "lazy", function () {
    return ke;
  }), t.d(n, "useState", function () {
    return Y;
  }), t.d(n, "useReducer", function () {
    return K;
  }), t.d(n, "useEffect", function () {
    return $;
  }), t.d(n, "useLayoutEffect", function () {
    return J;
  }), t.d(n, "useRef", function () {
    return Q;
  }), t.d(n, "useImperativeHandle", function () {
    return ee;
  }), t.d(n, "useMemo", function () {
    return ne;
  }), t.d(n, "useCallback", function () {
    return te;
  }), t.d(n, "useContext", function () {
    return ae;
  }), t.d(n, "useDebugValue", function () {
    return oe;
  }), t.d(n, "useErrorBoundary", function () {
    return re;
  }), t.d(n, "createElement", function () {
    return h;
  }), t.d(n, "createContext", function () {
    return U;
  }), t.d(n, "createRef", function () {
    return v;
  }), t.d(n, "Fragment", function () {
    return g;
  }), t.d(n, "Component", function () {
    return y;
  });

  var fe = function (e) {
    var n, t;

    function a(n) {
      var t;
      return (t = e.call(this, n) || this).isPureReactComponent = !0, t;
    }

    return t = e, (n = a).prototype = Object.create(t.prototype), n.prototype.constructor = n, n.__proto__ = t, a.prototype.shouldComponentUpdate = function (e, n) {
      return de(this.props, e) || de(this.state, n);
    }, a;
  }(y);

  function me(e, n) {
    function t(e) {
      var t = this.props.ref,
          a = t == e.ref;
      return !a && t && (t.call ? t(null) : t.current = null), n ? !n(this.props, e) || !a : de(this.props, e);
    }

    function a(n) {
      return this.shouldComponentUpdate = t, h(e, pe({}, n));
    }

    return a.prototype.isReactComponent = !0, a.displayName = "Memo(" + (e.displayName || e.name) + ")", a.t = !0, a;
  }

  var he = a.__b;

  function _e(e) {
    function n(n) {
      var t = pe({}, n);
      return delete t.ref, e(t, n.ref);
    }

    return n.prototype.isReactComponent = n.t = !0, n.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", n;
  }

  a.__b = function (e) {
    e.type && e.type.t && e.ref && (e.props.ref = e.ref, e.ref = null), he && he(e);
  };

  var ve = function ve(e, n) {
    return e ? w(e).reduce(function (e, t, a) {
      return e.concat(n(t, a));
    }, []) : null;
  },
      ge = {
    map: ve,
    forEach: ve,
    count: function count(e) {
      return e ? w(e).length : 0;
    },
    only: function only(e) {
      if (1 !== (e = w(e)).length) throw new Error("Children.only() expects only one child.");
      return e[0];
    },
    toArray: w
  },
      ye = a.__e;

  function be(e) {
    return e && ((e = pe({}, e)).__c = null, e.__k = e.__k && e.__k.map(be)), e;
  }

  function Ce() {
    this.__u = 0, this.o = null, this.__b = null;
  }

  function Le(e) {
    var n = e.__.__c;
    return n && n.u && n.u(e);
  }

  function ke(e) {
    var n, t, a;

    function o(o) {
      if (n || (n = e()).then(function (e) {
        t = e.default || e;
      }, function (e) {
        a = e;
      }), a) throw a;
      if (!t) throw n;
      return h(t, o);
    }

    return o.displayName = "Lazy", o.t = !0, o;
  }

  function xe() {
    this.i = null, this.l = null;
  }

  a.__e = function (e, n, t) {
    if (e.then) for (var a, o = n; o = o.__;) {
      if ((a = o.__c) && a.__c) return a.__c(e, n.__c);
    }
    ye(e, n, t);
  }, (Ce.prototype = new y()).__c = function (e, n) {
    var t = this;
    null == t.o && (t.o = []), t.o.push(n);

    var a = Le(t.__v),
        o = !1,
        r = function r() {
      o || (o = !0, a ? a(l) : l());
    };

    n.__c = n.componentWillUnmount, n.componentWillUnmount = function () {
      r(), n.__c && n.__c();
    };

    var l = function l() {
      var e;
      if (! --t.__u) for (t.__v.__k[0] = t.state.u, t.setState({
        u: t.__b = null
      }); e = t.o.pop();) {
        e.forceUpdate();
      }
    };

    t.__u++ || t.setState({
      u: t.__b = t.__v.__k[0]
    }), e.then(r, r);
  }, Ce.prototype.render = function (e, n) {
    return this.__b && (this.__v.__k[0] = be(this.__b), this.__b = null), [h(y, null, n.u ? null : e.children), n.u && e.fallback];
  };

  var we = function we(e, n, t) {
    if (++t[1] === t[0] && e.l.delete(n), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.l.size)) for (t = e.i; t;) {
      for (; t.length > 3;) {
        t.pop()();
      }

      if (t[1] < t[0]) break;
      e.i = t = t[2];
    }
  };

  (xe.prototype = new y()).u = function (e) {
    var n = this,
        t = Le(n.__v),
        a = n.l.get(e);
    return a[0]++, function (o) {
      var r = function r() {
        n.props.revealOrder ? (a.push(o), we(n, e, a)) : o();
      };

      t ? t(r) : r();
    };
  }, xe.prototype.render = function (e) {
    this.i = null, this.l = new Map();
    var n = w(e.children);
    e.revealOrder && "b" === e.revealOrder[0] && n.reverse();

    for (var t = n.length; t--;) {
      this.l.set(n[t], this.i = [1, 0, this.i]);
    }

    return e.children;
  }, xe.prototype.componentDidUpdate = xe.prototype.componentDidMount = function () {
    var e = this;
    e.l.forEach(function (n, t) {
      we(e, t, n);
    });
  };

  var Se = function () {
    function e() {}

    var n = e.prototype;
    return n.getChildContext = function () {
      return this.props.context;
    }, n.render = function (e) {
      return e.children;
    }, e;
  }();

  function Me(e) {
    var n = this,
        t = e.container,
        a = h(Se, {
      context: n.context
    }, e.vnode);
    return n.s && n.s !== t && (n.v.parentNode && n.s.removeChild(n.v), O(n.h), n.p = !1), e.vnode ? n.p ? (t.__k = n.__k, P(a, t), n.__k = t.__k) : (n.v = document.createTextNode(""), Z("", t), t.appendChild(n.v), n.p = !0, n.s = t, P(a, t, n.v), n.__k = n.v.__k) : n.p && (n.v.parentNode && n.s.removeChild(n.v), O(n.h)), n.h = a, n.componentWillUnmount = function () {
      n.v.parentNode && n.s.removeChild(n.v), O(n.h);
    }, null;
  }

  function Ee(e, n) {
    return h(Me, {
      vnode: e,
      container: n
    });
  }

  var Te = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/;
  y.prototype.isReactComponent = {};
  var Ae = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;

  function Ne(e, n, t) {
    if (null == n.__k) for (; n.firstChild;) {
      n.removeChild(n.firstChild);
    }
    return P(e, n), "function" == typeof t && t(), e ? e.__c : null;
  }

  function Ie(e, n, t) {
    return Z(e, n), "function" == typeof t && t(), e ? e.__c : null;
  }

  var Oe = a.event;

  function He(e, n) {
    e["UNSAFE_" + n] && !e[n] && Object.defineProperty(e, n, {
      configurable: !1,
      get: function get() {
        return this["UNSAFE_" + n];
      },
      set: function set(e) {
        this["UNSAFE_" + n] = e;
      }
    });
  }

  a.event = function (e) {
    Oe && (e = Oe(e)), e.persist = function () {};
    var n = !1,
        t = !1,
        a = e.stopPropagation;

    e.stopPropagation = function () {
      a.call(e), n = !0;
    };

    var o = e.preventDefault;
    return e.preventDefault = function () {
      o.call(e), t = !0;
    }, e.isPropagationStopped = function () {
      return n;
    }, e.isDefaultPrevented = function () {
      return t;
    }, e.nativeEvent = e;
  };

  var Pe = {
    configurable: !0,
    get: function get() {
      return this.class;
    }
  },
      Ze = a.vnode;

  a.vnode = function (e) {
    e.$$typeof = Ae;
    var n = e.type,
        t = e.props;

    if (n) {
      if (t.class != t.className && (Pe.enumerable = "className" in t, null != t.className && (t.class = t.className), Object.defineProperty(t, "className", Pe)), "function" != typeof n) {
        var a, o, r;

        for (r in t.defaultValue && void 0 !== t.value && (t.value || 0 === t.value || (t.value = t.defaultValue), delete t.defaultValue), Array.isArray(t.value) && t.multiple && "select" === n && (w(t.children).forEach(function (e) {
          -1 != t.value.indexOf(e.props.value) && (e.props.selected = !0);
        }), delete t.value), t) {
          if (a = Te.test(r)) break;
        }

        if (a) for (r in o = e.props = {}, t) {
          o[Te.test(r) ? r.replace(/[A-Z0-9]/, "-$&").toLowerCase() : r] = t[r];
        }
      }

      !function (n) {
        var t = e.type,
            a = e.props;

        if (a && "string" == typeof t) {
          var o = {};

          for (var r in a) {
            /^on(Ani|Tra|Tou)/.test(r) && (a[r.toLowerCase()] = a[r], delete a[r]), o[r.toLowerCase()] = r;
          }

          if (o.ondoubleclick && (a.ondblclick = a[o.ondoubleclick], delete a[o.ondoubleclick]), o.onbeforeinput && (a.onbeforeinput = a[o.onbeforeinput], delete a[o.onbeforeinput]), o.onchange && ("textarea" === t || "input" === t.toLowerCase() && !/^fil|che|ra/i.test(a.type))) {
            var l = o.oninput || "oninput";
            a[l] || (a[l] = a[o.onchange], delete a[o.onchange]);
          }
        }
      }(), "function" == typeof n && !n.m && n.prototype && (He(n.prototype, "componentWillMount"), He(n.prototype, "componentWillReceiveProps"), He(n.prototype, "componentWillUpdate"), n.m = !0);
    }

    Ze && Ze(e);
  };

  var De = "16.8.0";

  function Ue(e) {
    return h.bind(null, e);
  }

  function Re(e) {
    return !!e && e.$$typeof === Ae;
  }

  function Ve(e) {
    return Re(e) ? D.apply(null, arguments) : e;
  }

  function ze(e) {
    return !!e.__k && (P(null, e), !0);
  }

  function Fe(e) {
    return e && (e.base || 1 === e.nodeType && e) || null;
  }

  var qe = function qe(e, n) {
    return e(n);
  };

  n.default = {
    useState: Y,
    useReducer: K,
    useEffect: $,
    useLayoutEffect: J,
    useRef: Q,
    useImperativeHandle: ee,
    useMemo: ne,
    useCallback: te,
    useContext: ae,
    useDebugValue: oe,
    version: "16.8.0",
    Children: ge,
    render: Ne,
    hydrate: Ne,
    unmountComponentAtNode: ze,
    createPortal: Ee,
    createElement: h,
    createContext: U,
    createFactory: Ue,
    cloneElement: Ve,
    createRef: v,
    Fragment: g,
    isValidElement: Re,
    findDOMNode: Fe,
    Component: y,
    PureComponent: fe,
    memo: me,
    forwardRef: _e,
    unstable_batchedUpdates: qe,
    Suspense: Ce,
    SuspenseList: xe,
    lazy: ke
  };
}, function (e, n, t) {
  "use strict";

  var _a,
      o = this && this.__extends || (_a = function a(e, n) {
    return (_a = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, n) {
      e.__proto__ = n;
    } || function (e, n) {
      for (var t in n) {
        n.hasOwnProperty(t) && (e[t] = n[t]);
      }
    })(e, n);
  }, function (e, n) {
    function t() {
      this.constructor = e;
    }

    _a(e, n), e.prototype = null === n ? Object.create(n) : (t.prototype = n.prototype, new t());
  }),
      r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var n, t = 1, a = arguments.length; t < a; t++) {
        for (var o in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      l = this && this.__rest || function (e, n) {
    var t = {};

    for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (a = Object.getOwnPropertySymbols(e); o < a.length; o++) {
        n.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (t[a[o]] = e[a[o]]);
      }
    }

    return t;
  },
      i = this && this.__read || function (e, n) {
    var t = "function" == typeof Symbol && e[Symbol.iterator];
    if (!t) return e;
    var a,
        o,
        r = t.call(e),
        l = [];

    try {
      for (; (void 0 === n || n-- > 0) && !(a = r.next()).done;) {
        l.push(a.value);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        a && !a.done && (t = r.return) && t.call(r);
      } finally {
        if (o) throw o.error;
      }
    }

    return l;
  },
      c = this && this.__spread || function () {
    for (var e = [], n = 0; n < arguments.length; n++) {
      e = e.concat(i(arguments[n]));
    }

    return e;
  };

  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var s = t(0),
      u = t(20),
      p = t(4);
  n.STATUS = {
    FAILED: "failed",
    LOADED: "loaded",
    LOADING: "loading",
    PENDING: "pending",
    READY: "ready",
    UNSUPPORTED: "unsupported"
  };

  var d = Object.create(null),
      f = function (e) {
    function t(t) {
      var a = e.call(this, t) || this;
      return a._isMounted = !1, a.handleLoad = function (e) {
        a._isMounted && a.setState({
          content: e,
          status: n.STATUS.LOADED
        }, a.getElement);
      }, a.handleError = function (e) {
        var t = a.props.onError,
            o = "Browser does not support SVG" === e.message ? n.STATUS.UNSUPPORTED : n.STATUS.FAILED;
        a._isMounted && a.setState({
          status: o
        }, function () {
          "function" == typeof t && t(e);
        });
      }, a.request = function () {
        var e = a.props,
            t = e.cacheRequests,
            o = e.src;

        try {
          return t && (d[o] = {
            content: "",
            status: n.STATUS.LOADING,
            queue: []
          }), fetch(o).then(function (e) {
            var n = e.headers.get("content-type"),
                t = i((n || "").split(/ ?; ?/), 1)[0];
            if (e.status > 299) throw new p.InlineSVGError("Not Found");
            if (!["image/svg+xml", "text/plain"].some(function (e) {
              return t.indexOf(e) >= 0;
            })) throw new p.InlineSVGError("Content type isn't valid: " + t);
            return e.text();
          }).then(function (e) {
            if (a.handleLoad(e), t) {
              var r = d[o];
              r && (r.content = e, r.status = n.STATUS.LOADED, r.queue = r.queue.filter(function (n) {
                return n(e), !1;
              }));
            }
          }).catch(function (e) {
            t && delete d[o], a.handleError(e);
          });
        } catch (e) {
          a.handleError(new p.InlineSVGError(e.message));
        }
      }, a.state = {
        content: "",
        element: null,
        hasCache: !!t.cacheRequests && !!d[t.src],
        status: n.STATUS.PENDING
      }, a.hash = t.uniqueHash || p.randomString(8), a;
    }

    return o(t, e), t.prototype.componentDidMount = function () {
      if (this._isMounted = !0, p.canUseDOM()) {
        var e = this.state.status,
            t = this.props.src;

        try {
          if (e === n.STATUS.PENDING) {
            if (!p.isSupportedEnvironment()) throw new p.InlineSVGError("Browser does not support SVG");
            if (!t) throw new p.InlineSVGError("Missing src");
            this.load();
          }
        } catch (e) {
          this.handleError(e);
        }
      } else this.handleError(new p.InlineSVGError("No DOM"));
    }, t.prototype.componentDidUpdate = function (e, t) {
      if (p.canUseDOM()) {
        var a = this.state,
            o = a.hasCache,
            r = a.status,
            l = this.props,
            i = l.onLoad,
            c = l.src;

        if (t.status !== n.STATUS.READY && r === n.STATUS.READY && i && i(c, o), e.src !== c) {
          if (!c) return void this.handleError(new p.InlineSVGError("Missing src"));
          this.load();
        }
      }
    }, t.prototype.componentWillUnmount = function () {
      this._isMounted = !1;
    }, t.prototype.processSVG = function () {
      var e = this.state.content,
          n = this.props.preProcessor;
      return n ? n(e) : e;
    }, t.prototype.updateSVGAttributes = function (e) {
      var n = this,
          t = this.props,
          a = t.baseURL,
          o = void 0 === a ? "" : a,
          r = t.uniquifyIDs,
          l = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"],
          i = ["href", "xlink:href"];
      return r ? (c(e.children).map(function (e) {
        if (e.attributes && e.attributes.length) {
          var t = Object.values(e.attributes);
          t.forEach(function (e) {
            var t = e.value.match(/url\((.*?)\)/);
            t && t[1] && (e.value = e.value.replace(t[0], "url(" + o + t[1] + "__" + n.hash + ")"));
          }), l.forEach(function (e) {
            var a,
                o,
                r = t.find(function (n) {
              return n.name === e;
            });
            !r || (a = e, o = r.value, i.indexOf(a) >= 0 && o && o.indexOf("#") < 0) || (r.value = r.value + "__" + n.hash);
          });
        }

        return e.children.length && (e = n.updateSVGAttributes(e)), e;
      }), e) : e;
    }, t.prototype.getNode = function () {
      var e = this.props,
          n = e.description,
          t = e.title;

      try {
        var a = this.processSVG(),
            o = u.default(a, {
          nodeOnly: !0
        });
        if (!(o && o instanceof SVGSVGElement)) throw new p.InlineSVGError("Could not convert the src to a DOM Node");
        var r = this.updateSVGAttributes(o);

        if (n) {
          var l = r.querySelector("desc");
          l && l.parentNode && l.parentNode.removeChild(l);
          var i = document.createElement("desc");
          i.innerHTML = n, r.prepend(i);
        }

        if (t) {
          var c = r.querySelector("title");
          c && c.parentNode && c.parentNode.removeChild(c);
          var s = document.createElement("title");
          s.innerHTML = t, r.prepend(s);
        }

        return r;
      } catch (e) {
        this.handleError(e);
      }
    }, t.prototype.getElement = function () {
      try {
        var e = this.getNode(),
            t = u.default(e);
        if (!t || !s.isValidElement(t)) throw new p.InlineSVGError("Could not convert the src to a React element");
        this.setState({
          element: t,
          status: n.STATUS.READY
        });
      } catch (e) {
        this.handleError(new p.InlineSVGError(e.message));
      }
    }, t.prototype.load = function () {
      var e = this;
      this._isMounted && this.setState({
        content: "",
        element: null,
        status: n.STATUS.LOADING
      }, function () {
        var t = e.props,
            a = t.cacheRequests,
            o = t.src,
            r = a && d[o];
        if (r) r.status === n.STATUS.LOADING ? r.queue.push(e.handleLoad) : r.status === n.STATUS.LOADED && e.handleLoad(r.content);else {
          var l,
              i = o.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
          i ? l = i[1] ? atob(i[2]) : decodeURIComponent(i[2]) : o.indexOf("<svg") >= 0 && (l = o), l ? e.handleLoad(l) : e.request();
        }
      });
    }, t.prototype.render = function () {
      if (!p.canUseDOM()) return null;
      var e = this.state,
          t = e.element,
          a = e.status,
          o = this.props,
          i = (o.baseURL, o.cacheRequests, o.children),
          c = void 0 === i ? null : i,
          u = (o.description, o.innerRef),
          d = o.loader,
          f = void 0 === d ? null : d,
          m = (o.onError, o.onLoad, o.preProcessor, o.src, o.title, o.uniqueHash, o.uniquifyIDs, l(o, ["baseURL", "cacheRequests", "children", "description", "innerRef", "loader", "onError", "onLoad", "preProcessor", "src", "title", "uniqueHash", "uniquifyIDs"]));
      return t ? s.cloneElement(t, r({
        ref: u
      }, m)) : [n.STATUS.UNSUPPORTED, n.STATUS.FAILED].indexOf(a) > -1 ? c : f;
    }, t.defaultProps = {
      cacheRequests: !0,
      uniquifyIDs: !1
    }, t;
  }(s.PureComponent);

  n.default = f;
}, function (e, n, t) {
  "use strict";

  var a,
      o = function o() {
    return void 0 === a && (a = Boolean(window && document && document.all && !window.atob)), a;
  },
      r = function () {
    var e = {};
    return function (n) {
      if (void 0 === e[n]) {
        var t = document.querySelector(n);
        if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
          t = t.contentDocument.head;
        } catch (e) {
          t = null;
        }
        e[n] = t;
      }

      return e[n];
    };
  }(),
      l = {};

  function i(e, n, t) {
    for (var a = 0; a < n.length; a++) {
      var o = {
        css: n[a][1],
        media: n[a][2],
        sourceMap: n[a][3]
      };
      l[e][a] ? l[e][a](o) : l[e].push(h(o, t));
    }
  }

  function c(e) {
    var n = document.createElement("style"),
        a = e.attributes || {};

    if (void 0 === a.nonce) {
      var o = t.nc;
      o && (a.nonce = o);
    }

    if (Object.keys(a).forEach(function (e) {
      n.setAttribute(e, a[e]);
    }), "function" == typeof e.insert) e.insert(n);else {
      var l = r(e.insert || "head");
      if (!l) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      l.appendChild(n);
    }
    return n;
  }

  var s,
      u = (s = [], function (e, n) {
    return s[e] = n, s.filter(Boolean).join("\n");
  });

  function p(e, n, t, a) {
    var o = t ? "" : a.css;
    if (e.styleSheet) e.styleSheet.cssText = u(n, o);else {
      var r = document.createTextNode(o),
          l = e.childNodes;
      l[n] && e.removeChild(l[n]), l.length ? e.insertBefore(r, l[n]) : e.appendChild(r);
    }
  }

  function d(e, n, t) {
    var a = t.css,
        o = t.media,
        r = t.sourceMap;
    if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), r && btoa && (a += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = a;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(a));
    }
  }

  var f = null,
      m = 0;

  function h(e, n) {
    var t, a, o;

    if (n.singleton) {
      var r = m++;
      t = f || (f = c(n)), a = p.bind(null, t, r, !1), o = p.bind(null, t, r, !0);
    } else t = c(n), a = d.bind(null, t, n), o = function o() {
      !function (e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
      }(t);
    };

    return a(e), function (n) {
      if (n) {
        if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
        a(e = n);
      } else o();
    };
  }

  e.exports = function (e, n, t) {
    return (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o()), e = t.base ? e + t.base : e, n = n || [], l[e] || (l[e] = []), i(e, n, t), function (n) {
      if (n = n || [], "[object Array]" === Object.prototype.toString.call(n)) {
        l[e] || (l[e] = []), i(e, n, t);

        for (var a = n.length; a < l[e].length; a++) {
          l[e][a]();
        }

        l[e].length = n.length, 0 === l[e].length && delete l[e];
      }
    };
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = [];
    return n.toString = function () {
      return this.map(function (n) {
        var t = function (e, n) {
          var t = e[1] || "",
              a = e[3];
          if (!a) return t;

          if (n && "function" == typeof btoa) {
            var o = (l = a, i = btoa(unescape(encodeURIComponent(JSON.stringify(l)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(i), "/*# ".concat(c, " */")),
                r = a.sources.map(function (e) {
              return "/*# sourceURL=".concat(a.sourceRoot || "").concat(e, " */");
            });
            return [t].concat(r).concat([o]).join("\n");
          }

          var l, i, c;
          return [t].join("\n");
        }(n, e);

        return n[2] ? "@media ".concat(n[2], " {").concat(t, "}") : t;
      }).join("");
    }, n.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var a = 0; a < e.length; a++) {
        var o = [].concat(e[a]);
        t && (o[2] ? o[2] = "".concat(t, " and ").concat(o[2]) : o[2] = t), n.push(o);
      }
    }, n;
  };
}, function (e, n, t) {
  "use strict";

  var _a2,
      o = this && this.__extends || (_a2 = function a(e, n) {
    return (_a2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, n) {
      e.__proto__ = n;
    } || function (e, n) {
      for (var t in n) {
        n.hasOwnProperty(t) && (e[t] = n[t]);
      }
    })(e, n);
  }, function (e, n) {
    function t() {
      this.constructor = e;
    }

    _a2(e, n), e.prototype = null === n ? Object.create(n) : (t.prototype = n.prototype, new t());
  });

  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var r = t(5);
  n.canUseDOM = function () {
    return r.canUseDOM;
  }, n.supportsInlineSVG = function () {
    if (!document) return !1;
    var e = document.createElement("div");
    return e.innerHTML = "<svg />", e.firstChild && "http://www.w3.org/2000/svg" === e.firstChild.namespaceURI;
  };

  var l = function (e) {
    function n(n, t) {
      var a = e.call(this) || this;
      return a.name = "InlineSVGError", a.message = n, a.data = t, a;
    }

    return o(n, e), n;
  }(Error);

  n.InlineSVGError = l, n.isSupportedEnvironment = function () {
    return n.supportsInlineSVG() && "undefined" != typeof window && null !== window;
  }, n.randomString = function (e) {
    for (var n, t = "abcdefghijklmnopqrstuvwxyz", a = "" + t + t.toUpperCase() + "1234567890", o = "", r = 0; r < e; r++) {
      o += (n = a)[Math.floor(Math.random() * n.length)];
    }

    return o;
  };
}, function (e, n, t) {
  var a;
  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  !function () {
    "use strict";

    var o = !("undefined" == typeof window || !window.document || !window.document.createElement),
        r = {
      canUseDOM: o,
      canUseWorkers: "undefined" != typeof Worker,
      canUseEventListeners: o && !(!window.addEventListener && !window.attachEvent),
      canUseViewport: o && !!window.screen
    };
    void 0 === (a = function () {
      return r;
    }.call(n, t, n, e)) || (e.exports = a);
  }();
}, function (e, n, t) {
  var a = t(2),
      o = t(7);
  "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
  var r = {
    insert: "head",
    singleton: !1
  },
      l = (a(e.i, o, r), o.locals ? o.locals : {});
  e.exports = l;
}, function (e, n, t) {
  (n = t(3)(!1)).push([e.i, '.cleanslate .product-outer {\n  background-color: white !important;\n  border-radius: 4px !important;\n  border: 1px solid #e7eaed !important;\n  display: flex !important;\n  align-items: center !important;\n  margin-bottom: 20px !important;\n  box-sizing: border-box !important;\n  border-radius: 4px !important;\n  padding-left: 30px !important;\n  padding-right: 36px !important;\n  height: 23% !important;\n}\n\n.cleanslate .product-outer h1 {\n  color: #35353d !important;\n  margin: 0px !important;\n  font: 400 24px / 33px "Open Sans", sans-serif !important;\n}\n\n.cleanslate .product-outer p {\n  margin: 17px 0px 0px !important;\n  font: 400 16px / 22px "Open Sans", sans-serif !important;\n  color: #85858b !important;\n}\n\n.cleanslate .product-inner {\n  max-width: 450px !important;\n  margin: 0 60px 0 16px !important;\n}\n\n.cleanslate .product-link {\n  height: 24px !important;\n  width: 24px !important;\n}', ""]), e.exports = n;
}, function (e, n) {
  e.exports = '<svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 22H5c-1.7 0-3-1.3-3-3V8c0-1.7 1.3-3 3-3h6c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 1.7-1.3 3-3 3zM21 10c-.6 0-1-.4-1-1V4h-5c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1z" fill="#85858B"></path><path d="M10 15c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l11-11c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-11 11c-.2.2-.4.3-.7.3z" fill="#85858B"></path></svg>';
}, function (e, n, t) {
  var a = t(2),
      o = t(10);
  "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
  var r = {
    insert: "head",
    singleton: !1
  },
      l = (a(e.i, o, r), o.locals ? o.locals : {});
  e.exports = l;
}, function (e, n, t) {
  (n = t(3)(!1)).push([e.i, ".cleanslate .product-list {\n  display: flex !important;\n  height: 85% !important;\n  flex-direction: column !important;\n}\n\n.cleanslate .product-icon {\n  height: 100px !important;\n  width: 100px !important;\n}", ""]), e.exports = n;
}, function (e, n) {
  e.exports = '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M51.1766 24.1176V14.7059H48.8237V24.1176C49.2119 24.1176 49.606 24.1176 50.0002 24.1176C50.3943 24.1176 50.7884 24.1176 51.1766 24.1176ZM44.4413 24.7059L42.0002 15.6059L39.7296 16.1941L42.1708 25.3059C42.9413 25.0882 43.6708 24.8823 44.4413 24.7059ZM38.0884 27.0059L33.3708 18.8235L31.3355 20L36.0413 28.1706C36.7119 27.7706 37.3884 27.3765 38.0884 27.0176V27.0059ZM32.5472 30.8823L25.8825 24.2118L24.2119 25.8823L30.8825 32.547C31.4119 31.9706 31.9708 31.4118 32.5472 30.8823ZM28.1943 36.0529L20.0002 31.3353L18.8237 33.3706L26.9943 38.0765C27.3766 37.3882 27.7708 36.7118 28.1943 36.0529ZM25.3237 42.1706L16.2119 39.7294L15.6237 42L24.7061 44.4412C24.8825 43.6706 25.0884 42.9412 25.3237 42.1706ZM24.1178 48.8235C24.1178 49.2118 24.1178 49.6059 24.1178 50C24.1178 50.3941 24.1178 50.7882 24.1178 51.1765H14.7061V48.8235H24.1178ZM75.8825 51.1765H85.2943V48.8235H75.8825C75.8825 49.2118 75.8825 49.6059 75.8825 50C75.8825 50.3941 75.8825 50.7882 75.8825 51.1765ZM24.7061 55.5588C24.8708 56.3294 25.0766 57.0882 25.2943 57.8294L16.2119 60.2706L15.6237 58L24.7061 55.5588ZM84.3943 58L75.2943 55.5588L75.1884 56.0176C75.0472 56.6059 74.8766 57.2353 74.6884 57.8294L83.8002 60.2706L84.3943 58ZM27.0178 61.9117C27.3766 62.6117 27.7708 63.2882 28.1943 63.947L20.0237 68.6529L18.8472 66.6176L27.0178 61.9117ZM81.1355 66.6176L72.9649 61.9117C72.606 62.6117 72.2119 63.2882 71.7884 63.947L79.959 68.6529L81.1355 66.6176ZM30.8649 67.4412C31.3943 68.0294 31.9531 68.5765 32.5296 69.1059L25.8825 75.7882L24.2119 74.1176L30.8649 67.4412ZM75.7884 74.1176L69.1178 67.4529C68.5884 68.0412 68.0296 68.5882 67.4531 69.1176L74.1178 75.7882L75.7884 74.1176ZM36.0531 71.8C36.5766 72.1353 37.1178 72.4588 37.6708 72.7588L38.0884 72.9764L33.3825 81.147L31.3472 79.9706L36.0531 71.8ZM68.6649 80L63.959 71.8294C63.3002 72.2529 62.6237 72.647 61.9237 73.0059L66.6296 81.1765L68.6649 80ZM42.1943 74.7059C42.7825 74.8941 43.3708 75.0647 44.006 75.2059L44.4649 75.3117L42.0002 84.3941L39.7296 83.8059L42.1943 74.7059ZM60.2943 83.8176L57.8296 74.7059C57.0884 74.9412 56.3296 75.147 55.559 75.2941L58.0002 84.4059L60.2943 83.8176ZM51.1766 85.2941V75.8823C50.7884 75.8823 50.3943 75.8823 50.0002 75.8823C49.606 75.8823 49.2119 75.8823 48.8237 75.8823V85.2941H51.1766ZM83.7884 39.7294L84.3766 42L75.2943 44.4412C75.1296 43.6706 74.9237 42.9118 74.706 42.1706L83.7884 39.7294ZM80.0002 31.3353L81.1766 33.3706L73.006 38.0765C72.8708 37.8118 72.7296 37.5529 72.5884 37.3C73.0219 36.6154 73.3343 35.8612 73.5119 35.0706L80.0002 31.3353ZM74.1178 24.2118L75.7884 25.8823L72.3002 29.3706C72.0846 29.0779 71.8487 28.8007 71.5943 28.5412C71.2848 28.2383 70.9481 27.9646 70.5884 27.7235L74.1178 24.2118ZM66.6296 18.8235L68.6649 20L64.8119 26.6765C64.1243 26.8546 63.4678 27.1362 62.8649 27.5118C62.5531 27.3353 62.2355 27.1588 61.9119 26.9941L66.6296 18.8235ZM58.0002 15.6059L60.2708 16.1941L57.8296 25.3235C57.0884 25.0882 56.3296 24.8823 55.559 24.7353L58.0002 15.6059Z" fill="#52C1A3"></path><path d="M50 26.4704C53.8228 26.4641 57.5892 27.3931 60.9706 29.1763L53.7588 36.3881C50.7644 35.5595 47.5803 35.7419 44.7 36.907C41.8198 38.0721 39.4043 40.1547 37.8281 42.8321C36.2518 45.5096 35.6028 48.6322 35.9817 51.716C36.3605 54.7997 37.7461 57.6724 39.9235 59.8886C42.101 62.1049 44.9488 63.541 48.0254 63.9742C51.1019 64.4074 54.2355 63.8137 56.9404 62.2849C59.6452 60.7562 61.7702 58.3779 62.9859 55.5187C64.2017 52.6595 64.4403 49.479 63.6647 46.4704L70.9118 39.2234C73.2621 43.7852 74.0566 48.9903 73.1742 54.0455C72.2919 59.1007 69.7811 63.7289 66.0244 67.2248C62.2678 70.7207 57.4712 72.8926 52.3657 73.4096C47.2601 73.9265 42.1256 72.7602 37.7443 70.0884C33.3631 67.4165 29.9755 63.3856 28.0977 58.6099C26.2199 53.8341 25.9549 48.5754 27.343 43.6351C28.7311 38.6948 31.6963 34.3437 35.7867 31.2448C39.8771 28.146 44.8683 26.4694 50 26.4704Z" fill="#52C1A3"></path><path d="M69.9294 30.2001C70.3669 30.6371 70.714 31.1561 70.9508 31.7274C71.1877 32.2987 71.3095 32.911 71.3095 33.5295C71.3095 34.1479 71.1877 34.7603 70.9508 35.3315C70.714 35.9028 70.3669 36.4218 69.9294 36.8589L53.7941 52.9883C53.4731 53.3137 53.0643 53.5385 52.6176 53.6354L46.7352 54.8118C46.5797 54.8507 46.4179 54.8573 46.2598 54.8314C46.1016 54.8054 45.9504 54.7474 45.8154 54.661C45.6805 54.5745 45.5646 54.4613 45.475 54.3285C45.3853 54.1956 45.3238 54.0458 45.2941 53.8883C45.264 53.7368 45.264 53.5809 45.2941 53.4295L46.4705 47.5471C46.5674 47.1004 46.7922 46.6916 47.1176 46.3707L63.247 30.2354C63.6822 29.792 64.2008 29.4391 64.773 29.1972C65.3452 28.9552 65.9596 28.829 66.5808 28.8257C67.2021 28.8224 67.8178 28.9422 68.3925 29.1781C68.9672 29.4139 69.4896 29.7613 69.9294 30.2001Z" fill="#35888E"></path></svg>';
}, function (e, n) {
  e.exports = '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M51.1765 24.1176V14.7059H48.8235V24.1176C49.2118 24.1176 49.6059 24.1176 50 24.1176C50.3941 24.1176 50.7882 24.1176 51.1765 24.1176ZM44.4412 24.7059L42 15.6059L39.7294 16.1941L42.1706 25.3059C42.9412 25.0882 43.6706 24.8823 44.4412 24.7059ZM38.0882 27.0059L33.3706 18.8235L31.3353 20L36.0412 28.1706C36.7118 27.7706 37.3882 27.3765 38.0882 27.0176V27.0059ZM32.5471 30.8823L25.8824 24.2118L24.2118 25.8823L30.8824 32.547C31.4118 31.9706 31.9706 31.4118 32.5471 30.8823ZM28.1941 36.0529L20 31.3353L18.8235 33.3706L26.9941 38.0765C27.3765 37.3882 27.7706 36.7118 28.1941 36.0529ZM25.3235 42.1706L16.2118 39.7294L15.6235 42L24.7059 44.4412C24.8824 43.6706 25.0882 42.9412 25.3235 42.1706ZM24.1177 48.8235C24.1177 49.2118 24.1177 49.6059 24.1177 50C24.1177 50.3941 24.1177 50.7882 24.1177 51.1765H14.7059V48.8235H24.1177ZM75.8823 51.1765H85.2941V48.8235H75.8823C75.8823 49.2118 75.8823 49.6059 75.8823 50C75.8823 50.3941 75.8823 50.7882 75.8823 51.1765ZM24.7059 55.5588C24.8706 56.3294 25.0765 57.0882 25.2941 57.8294L16.2118 60.2706L15.6235 58L24.7059 55.5588ZM84.3941 58L75.2941 55.5588L75.1882 56.0176C75.0471 56.6059 74.8765 57.2353 74.6882 57.8294L83.8 60.2706L84.3941 58ZM27.0176 61.9117C27.1353 62.1412 27.2588 62.3765 27.3882 62.6059L23.1 66.8882L20.0235 68.6529L18.8471 66.6176L27.0176 61.9117ZM81.1353 66.6176L72.9647 61.9117C72.6059 62.6117 72.2118 63.2882 71.7882 63.947L79.9588 68.6529L81.1353 66.6176ZM69.1 67.4412L75.7882 74.1176L74.1176 75.7882L67.4529 69.1176C68.0294 68.5882 68.5882 68.0294 69.1176 67.4529L69.1 67.4412ZM63.9294 71.7941L68.6353 79.9647L66.6 81.1412L61.8941 72.9706C62.6118 72.6235 63.2882 72.2294 63.9471 71.8059L63.9294 71.7941ZM43.9824 75.1765C43.3941 75.0353 42.7647 74.8647 42.1706 74.6764L39.7294 83.7882L42 84.3764L44.4412 75.2941L43.9824 75.1765ZM57.8294 74.7059L60.2706 83.8176L58 84.4059L55.5588 75.2941C56.3294 75.1176 57.0882 74.9117 57.8294 74.7059ZM51.1765 75.8823V85.2941H48.8235V75.8823C49.2118 75.8823 49.6059 75.8823 50 75.8823C50.3941 75.8823 50.7882 75.8823 51.1765 75.8823ZM38.0882 73.0059L37.6471 72.7647L37.3412 72.5941L33.1647 76.7706L31.3353 80L33.3706 81.1765L38.0882 73.0059ZM83.7882 39.7529L84.3765 42.0235L75.2941 44.4412C75.1294 43.6706 74.9235 42.9118 74.7059 42.1706L83.7882 39.7529ZM80 31.3353L81.1765 33.3706L73.0059 38.0765C72.6471 37.3765 72.2529 36.7 71.8294 36.0412L80 31.3353ZM74.1176 24.2118L75.7882 25.8823L69.1176 32.547C68.5882 31.9588 68.0294 31.4118 67.4529 30.8823L74.1176 24.2118ZM66.6294 18.8235L68.6647 20L63.9588 28.1706C63.3 27.747 62.6235 27.3529 61.9235 26.9941L66.6294 18.8235ZM58 15.6059L60.2706 16.1941L57.8294 25.3235C57.0882 25.0882 56.3294 24.8823 55.5588 24.7353L58 15.6059Z" fill="#F9CF71"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M26.4706 49.9999C26.4706 45.3463 27.8506 40.7971 30.436 36.9277C33.0215 33.0583 36.6963 30.0425 40.9957 28.2616C45.2951 26.4807 50.0261 26.0148 54.5904 26.9226C59.1546 27.8305 63.3472 30.0715 66.6378 33.3621C69.9285 36.6528 72.1694 40.8453 73.0773 45.4096C73.9852 49.9738 73.5192 54.7048 71.7384 59.0043C69.9575 63.3037 66.9416 66.9785 63.0723 69.5639C59.2029 72.1494 54.6537 73.5294 50 73.5294C43.7596 73.5294 37.7748 71.0504 33.3622 66.6377C28.9496 62.2251 26.4706 56.2403 26.4706 49.9999ZM64.1177 49.9999C64.1177 47.2077 63.2897 44.4782 61.7384 42.1566C60.1871 39.835 57.9823 38.0255 55.4026 36.9569C52.8229 35.8884 49.9843 35.6088 47.2458 36.1536C44.5072 36.6983 41.9917 38.0429 40.0173 40.0173C38.0429 41.9916 36.6984 44.5072 36.1536 47.2457C35.6089 49.9843 35.8885 52.8229 36.957 55.4025C38.0255 57.9822 39.835 60.1871 42.1567 61.7383C44.4783 63.2896 47.2078 64.1176 50 64.1176C53.7442 64.1176 57.3351 62.6302 59.9827 59.9826C62.6303 57.3351 64.1177 53.7442 64.1177 49.9999Z" fill="#F9CF71"></path><path d="M35.2939 71.3175L30.9586 75.6528C30.0627 76.4631 28.8895 76.8979 27.6819 76.8671C26.4743 76.8363 25.3248 76.3423 24.4714 75.4874C23.618 74.6324 23.126 73.4821 23.0974 72.2744C23.0687 71.0668 23.5055 69.8943 24.3175 68.9999L28.6645 64.6528C30.4516 67.2582 32.698 69.5166 35.2939 71.3175Z" fill="#DEA278"></path></svg>';
}, function (e, n) {
  e.exports = '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M51.1765 21.7647V14.7059H48.8235V21.9647C49.1193 21.858 49.4278 21.7908 49.7412 21.7647H49.9118H50.3941H51.1765ZM44.4412 24.7059L42 15.6059L39.7294 16.1941L42.1706 25.3059C42.9412 25.0882 43.6706 24.8823 44.4412 24.7059ZM38.0882 27.0059L33.3706 18.8235L31.3353 20L36.0412 28.1706C36.7118 27.7706 37.3882 27.3765 38.0882 27.0176V27.0059ZM32.5471 30.8765L25.8824 24.2118L24.2118 25.8823L30.8824 32.547C31.4118 31.9706 31.9706 31.4118 32.5471 30.8882V30.8765ZM28.1941 36.0412L20 31.3353L18.8235 33.3706L26.9941 38.0765C27.3765 37.3882 27.7706 36.7118 28.1941 36.0529V36.0412ZM25.3235 42.1588L16.2118 39.7294L15.6235 42L24.7059 44.4412C24.8824 43.6706 25.0882 42.9412 25.3235 42.1706V42.1588ZM85.2941 51.1765H78.0353C78.1683 50.7985 78.2359 50.4007 78.2353 50C78.2353 49.6059 78.2353 49.2118 78.2353 48.8235H85.2941V51.1765ZM24.1177 50C24.1177 49.6059 24.1177 49.2118 24.1177 48.8235H14.7059V51.1765H24.1177C24.1177 50.7882 24.1177 50.3941 24.1177 50ZM24.7059 55.5588C24.8706 56.3294 25.0765 57.0882 25.2941 57.8294L16.2118 60.2706L15.6235 58L24.7059 55.5588ZM84.3941 58L75.2941 55.5588L75.1882 56.0176C75.0471 56.6059 74.8765 57.2353 74.6882 57.8294L83.8 60.2706L84.3941 58ZM27.0176 61.9117C27.3765 62.6117 27.7706 63.2882 28.1941 63.947L20.0235 68.6529L18.8471 66.6176L27.0176 61.9117ZM81.1353 66.6176L72.9647 61.9117C72.6059 62.6117 72.2118 63.2882 71.7882 63.947L79.9588 68.6529L81.1353 66.6176ZM30.8647 67.4412C31.3941 68.0294 31.9529 68.5765 32.5294 69.1059L25.8824 75.7882L24.2118 74.1176L30.8647 67.4412ZM75.7882 74.1176L69.1176 67.4529C68.5882 68.0412 68.0294 68.5882 67.4529 69.1176L74.1176 75.7882L75.7882 74.1176ZM36.0529 71.8C36.5765 72.1412 37.1176 72.4588 37.6706 72.7588L38.0882 72.9764L33.3824 81.147L31.3471 79.9706L36.0529 71.8ZM68.6647 80L63.9588 71.8294C63.3 72.2529 62.6235 72.647 61.9235 73.0059L66.6294 81.1765L68.6647 80ZM42.1941 74.7059C42.7824 74.8941 43.3706 75.0647 44.0059 75.2059L44.4647 75.3117L42 84.3941L39.7294 83.8059L42.1941 74.7059ZM60.2941 83.8176L57.8294 74.7059C57.0882 74.9412 56.3294 75.147 55.5588 75.2941L58 84.4059L60.2941 83.8176ZM51.1765 85.2941V75.8823C50.7882 75.8823 50.3941 75.8823 50 75.8823C49.6059 75.8823 49.2118 75.8823 48.8235 75.8823V85.2941H51.1765ZM83.7882 39.7294L84.3765 42L77.5412 43.8353C77.3706 43.0647 77.1647 42.3059 76.9529 41.5588L83.7882 39.7294ZM80 31.3353L81.1765 33.3706L75.0471 36.9C74.6824 36.2 74.2882 35.5235 73.8706 34.8647L80 31.3353ZM74.1176 24.2118L75.7882 25.8823L70.7823 30.8882C70.2471 30.3 69.6941 29.7588 69.1176 29.2235L74.1176 24.2118ZM66.6294 18.8235L68.6647 20L65.1353 26.1294C64.4765 25.7118 63.8 25.3176 63.1 24.9529L66.6294 18.8235ZM58 15.6059L60.2706 16.1941L58.4412 23.047C57.6941 22.8176 56.9353 22.6118 56.1647 22.4588L58 15.6059Z" fill="#BC89E9"></path><path d="M46.4708 26.7354V36.3295C44.061 36.9521 41.8586 38.2006 40.0868 39.9486C38.315 41.6967 37.0368 43.882 36.3819 46.2832C35.7269 48.6844 35.7183 51.2161 36.3571 53.6217C36.9959 56.0273 38.2592 58.2212 40.0192 59.9811C41.7791 61.7411 43.9731 63.0045 46.3786 63.6432C48.7842 64.282 51.3159 64.2735 53.7171 63.6185C56.1183 62.9635 58.3037 61.6853 60.0517 59.9135C61.7997 58.1418 63.0483 55.9394 63.6708 53.5295H73.2649C72.6117 57.8324 70.7779 61.8699 67.9674 65.1929C65.1569 68.516 61.4798 70.9944 57.3449 72.3526C53.2101 73.7108 48.7795 73.8956 44.546 72.8864C40.3124 71.8772 36.4417 69.7136 33.3642 66.6361C30.2867 63.5587 28.1231 59.6879 27.1139 55.4544C26.1047 51.2208 26.2895 46.7902 27.6477 42.6554C29.0059 38.5205 31.4843 34.8434 34.8074 32.0329C38.1304 29.2224 42.1679 27.3886 46.4708 26.7354Z" fill="#BC89E9"></path><path d="M75.8823 50C75.8823 50.3121 75.7583 50.6113 75.5377 50.8319C75.3171 51.0526 75.0178 51.1765 74.7058 51.1765H62.9411C62.6438 51.1773 62.3572 51.0656 62.1389 50.8637C61.9207 50.6618 61.7869 50.3848 61.7646 50.0883V50C61.7651 46.9142 60.5531 43.9517 58.3898 41.751C56.2266 39.5504 53.2853 38.2878 50.1999 38.2353H49.9999C49.6879 38.2353 49.3887 38.1114 49.168 37.8907C48.9474 37.6701 48.8235 37.3709 48.8235 37.0589V25.2941C48.8226 24.9968 48.9344 24.7102 49.1363 24.492C49.3382 24.2737 49.6152 24.14 49.9117 24.1177H49.9999C56.8643 24.1177 63.4476 26.8446 68.3015 31.6984C73.1554 36.5523 75.8823 43.1356 75.8823 50Z" fill="#8E5FB7"></path></svg>';
}, function (e, n) {
  e.exports = '<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M51.1765 14.7059V24.1176C50.7882 24.1176 50.3941 24.1176 50 24.1176C49.6059 24.1176 49.2118 24.1176 48.8235 24.1176V14.7059H51.1765ZM42 15.6059L44.4412 24.7059C43.6706 24.8706 42.9118 25.0765 42.1706 25.2941L39.7294 16.2118L42 15.6059ZM38.0882 27.0176L33.3706 18.8235L31.3353 20L36.0412 28.1706C36.7118 27.7706 37.3882 27.3765 38.0882 27.0176ZM32.5471 30.8823L25.8824 24.2118L24.2118 25.8823L30.8824 32.547C31.4118 31.9706 31.9706 31.4118 32.5471 30.8823ZM28.1941 36.0529L20 31.3353L18.8235 33.3706L26.9941 38.0765C27.3765 37.3882 27.7706 36.7118 28.1941 36.0529ZM25.3235 42.1706L16.2118 39.7294L15.6235 42L24.7059 44.4412C24.8824 43.6706 25.0882 42.9412 25.3235 42.1706ZM24.1177 48.8235C24.1177 49.2118 24.1177 49.6059 24.1177 50C24.1177 50.3941 24.1177 50.7882 24.1177 51.1765H14.7059V48.8235H24.1177ZM75.8823 51.1765H85.2941V48.8235H75.8823C75.8823 49.2118 75.8823 49.6059 75.8823 50C75.8823 50.3941 75.8823 50.7882 75.8823 51.1765ZM24.7059 55.5588C24.8706 56.3294 25.0765 57.0882 25.2941 57.8294L16.2118 60.2706L15.6235 58L24.7059 55.5588ZM84.3941 58L75.2941 55.5588L75.1882 56.0176C75.0471 56.6059 74.8765 57.2353 74.6882 57.8294L83.8 60.2706L84.3941 58ZM27.0176 61.9117C27.3765 62.6117 27.7706 63.2882 28.1941 63.947L20.0235 68.6529L18.8471 66.6176L27.0176 61.9117ZM81.1353 66.6176L72.9647 61.9117C72.6059 62.6117 72.2118 63.2882 71.7882 63.947L79.9588 68.6529L81.1353 66.6176ZM30.8647 67.4412C31.3941 68.0294 31.9529 68.5765 32.5294 69.1059L25.8824 75.7882L24.2118 74.1176L30.8647 67.4412ZM75.7882 74.1176L69.1176 67.4529C68.5882 68.0412 68.0294 68.5882 67.4529 69.1176L74.1176 75.7882L75.7882 74.1176ZM36.0529 71.8C36.5765 72.1353 37.1176 72.4588 37.6706 72.7588L38.0882 72.9764L33.3824 81.147L31.3471 79.9706L36.0529 71.8ZM68.6647 80L63.9588 71.8294C63.3 72.2529 62.6235 72.647 61.9235 73.0059L66.6294 81.1765L68.6647 80ZM42.1941 74.7059C42.7824 74.8941 43.3706 75.0647 44.0059 75.2059L44.4647 75.3117L42 84.3941L39.7294 83.8059L42.1941 74.7059ZM60.2941 83.8176L57.8294 74.7059C57.0882 74.9412 56.3294 75.147 55.5588 75.2941L58 84.4059L60.2941 83.8176ZM51.1765 85.2941V75.8823C50.7882 75.8823 50.3941 75.8823 50 75.8823C49.6059 75.8823 49.2118 75.8823 48.8235 75.8823V85.2941H51.1765ZM83.7882 39.7294L84.3765 42L75.2941 44.4412C75.1294 43.6706 74.9235 42.9118 74.7059 42.1706L83.7882 39.7294ZM80 31.3353L81.1765 33.3706L77.2882 35.6176C77.1121 35.2243 76.8517 34.8744 76.5254 34.5929C76.1991 34.3113 75.8149 34.1049 75.4 33.9882L80 31.3353ZM74.1176 24.2118L75.7882 25.8823L69.3176 32.3529L70.1059 28.2353L74.1176 24.2118ZM60.2706 16.2118L58 15.6235L55.5588 24.7059C56.3294 24.8706 57.0882 25.0765 57.8294 25.2941L60.2706 16.2118Z" fill="#E56473"></path><path d="M49.9998 26.4705C52.9467 26.4676 55.868 27.0184 58.6116 28.0941L51.6527 35.9764C51.1039 35.9152 50.5521 35.8838 49.9998 35.8823C47.3657 35.8829 44.7842 36.6204 42.5474 38.0115C40.3105 39.4026 38.5075 41.3918 37.3421 43.7541C36.1767 46.1165 35.6955 48.7577 35.9529 51.3793C36.2102 54.0008 37.1959 56.498 38.7984 58.5886C40.4009 60.6792 42.5564 62.2798 45.0211 63.2094C47.4857 64.1389 50.1613 64.3604 52.7453 63.8487C55.3292 63.337 57.7185 62.1126 59.643 60.314C61.5674 58.5153 62.9502 56.2141 63.6351 53.6705L72.6175 43.4941C73.9818 48.2362 73.8208 53.2873 72.1572 57.9329C70.4935 62.5785 67.4114 66.5835 63.3468 69.3814C59.2821 72.1793 54.4408 73.6285 49.5073 73.5241C44.5739 73.4197 39.7982 71.7668 35.8557 68.7994C31.9131 65.832 29.0033 61.7001 27.5377 56.9883C26.0721 52.2764 26.125 47.2231 27.6889 42.5429C29.2527 37.8628 32.2484 33.7927 36.2522 30.9085C40.256 28.0242 45.0653 26.4717 49.9998 26.4705Z" fill="#E56473"></path><path d="M75.1178 36.5823C75.071 36.4782 74.9949 36.3899 74.8989 36.3283C74.8028 36.2667 74.6908 36.2343 74.5767 36.2352H66.1767L69.0061 21.5293C69.031 21.4024 69.0134 21.2708 68.9559 21.1549C68.8985 21.039 68.8045 20.9452 68.6884 20.8882C68.6023 20.846 68.5078 20.8239 68.4119 20.8235C68.3305 20.8241 68.2502 20.8429 68.1769 20.8785C68.1036 20.9141 68.0392 20.9656 67.9884 21.0293L50.8649 40.4411C50.7903 40.526 50.7417 40.6307 50.725 40.7425C50.7083 40.8543 50.7242 40.9685 50.7707 41.0715C50.8173 41.1746 50.8925 41.262 50.9875 41.3234C51.0824 41.3847 51.193 41.4174 51.3061 41.4176H59.7061L56.8767 56.1235C56.8517 56.2504 56.8694 56.382 56.9268 56.4979C56.9842 56.6138 57.0782 56.7076 57.1943 56.7646C57.3103 56.8211 57.4417 56.8379 57.5682 56.8124C57.6947 56.7869 57.8093 56.7205 57.8943 56.6235L75.0178 37.2117C75.0932 37.1275 75.1427 37.0233 75.1605 36.9117C75.1782 36.8001 75.1634 36.6857 75.1178 36.5823Z" fill="#B14A56"></path></svg>';
}, function (e, n, t) {
  var a = t(2),
      o = t(16);
  "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
  var r = {
    insert: "head",
    singleton: !1
  },
      l = (a(e.i, o, r), o.locals ? o.locals : {});
  e.exports = l;
}, function (e, n, t) {
  (n = t(3)(!1)).push([e.i, '.cleanslate .launcher-container {\n  background-color: #f8f8f8 !important;\n  font-family: "Open Sans", sans-serif !important;\n  padding: 30px 40px !important;\n  height: 100vh !important;\n  width: fit-content !important;\n  box-sizing: border-box !important;\n}\n\n.cleanslate .launcher-outer {\n  position: absolute !important;\n  background-color: rgba(127,143,164,0.5) !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n}', ""]), e.exports = n;
}, function (e, n, t) {
  var a = t(2),
      o = t(18);
  "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
  var r = {
    insert: "head",
    singleton: !1
  },
      l = (a(e.i, o, r), o.locals ? o.locals : {});
  e.exports = l;
}, function (e, n, t) {
  (n = t(3)(!1)).push([e.i, '/*!\n* CleanSlate\n*   github.com/premasagar/cleanslate\n*\n*/\n\n.cleanslate.cleanslate,\n.cleanslate .cleanslate h1,\n.cleanslate .cleanslate h2,\n.cleanslate .cleanslate h3,\n.cleanslate .cleanslate h4,\n.cleanslate .cleanslate h5,\n.cleanslate .cleanslate h6,\n.cleanslate .cleanslate p,\n.cleanslate .cleanslate td,\n.cleanslate .cleanslate dl,\n.cleanslate .cleanslate tr,\n.cleanslate .cleanslate dt,\n.cleanslate .cleanslate ol,\n.cleanslate .cleanslate form,\n.cleanslate .cleanslate select,\n.cleanslate .cleanslate option,\n.cleanslate .cleanslate pre,\n.cleanslate .cleanslate div,\n.cleanslate .cleanslate table,\n.cleanslate .cleanslate th,\n.cleanslate .cleanslate tbody,\n.cleanslate .cleanslate tfoot,\n.cleanslate .cleanslate caption,\n.cleanslate .cleanslate thead,\n.cleanslate .cleanslate ul,\n.cleanslate .cleanslate li,\n.cleanslate .cleanslate address,\n.cleanslate .cleanslate blockquote,\n.cleanslate .cleanslate dd,\n.cleanslate .cleanslate fieldset,\n.cleanslate .cleanslate li,\n.cleanslate .cleanslate iframe,\n.cleanslate .cleanslate strong,\n.cleanslate .cleanslate legend,\n.cleanslate .cleanslate em,\n.cleanslate .cleanslate summary,\n.cleanslate .cleanslate cite,\n.cleanslate .cleanslate span,\n.cleanslate .cleanslate input,\n.cleanslate .cleanslate sup,\n.cleanslate .cleanslate label,\n.cleanslate .cleanslate dfn,\n.cleanslate .cleanslate object,\n.cleanslate .cleanslate big,\n.cleanslate .cleanslate q,\n.cleanslate .cleanslate samp,\n.cleanslate .cleanslate acronym,\n.cleanslate .cleanslate small,\n.cleanslate .cleanslate img,\n.cleanslate .cleanslate strike,\n.cleanslate .cleanslate code,\n.cleanslate .cleanslate sub,\n.cleanslate .cleanslate ins,\n.cleanslate .cleanslate textarea,\n.cleanslate .cleanslate button,\n.cleanslate .cleanslate var,\n.cleanslate .cleanslate a,\n.cleanslate .cleanslate abbr,\n.cleanslate .cleanslate applet,\n.cleanslate .cleanslate del,\n.cleanslate .cleanslate kbd,\n.cleanslate .cleanslate tt,\n.cleanslate .cleanslate b,\n.cleanslate .cleanslate i,\n.cleanslate .cleanslate hr,\n.cleanslate .cleanslate article,\n.cleanslate .cleanslate aside,\n.cleanslate .cleanslate figure,\n.cleanslate .cleanslate figcaption,\n.cleanslate .cleanslate footer,\n.cleanslate .cleanslate header,\n.cleanslate .cleanslate menu,\n.cleanslate .cleanslate nav,\n.cleanslate .cleanslate section,\n.cleanslate .cleanslate time,\n.cleanslate .cleanslate mark,\n.cleanslate .cleanslate audio,\n.cleanslate .cleanslate video,\n.cleanslate .cleanslate abbr,\n.cleanslate .cleanslate address,\n.cleanslate .cleanslate area,\n.cleanslate .cleanslate blockquote,\n.cleanslate .cleanslate canvas,\n.cleanslate .cleanslate caption,\n.cleanslate .cleanslate cite,\n.cleanslate .cleanslate code,\n.cleanslate .cleanslate colgroup,\n.cleanslate .cleanslate col,\n.cleanslate .cleanslate datalist,\n.cleanslate .cleanslate fieldset,\n.cleanslate .cleanslate main,\n.cleanslate .cleanslate map,\n.cleanslate .cleanslate meta,\n.cleanslate .cleanslate optgroup,\n.cleanslate .cleanslate output,\n.cleanslate .cleanslate progress,\n.cleanslate .cleanslate svg {\n  background-attachment: scroll !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  background-position: 0 0 !important;\n  background-repeat: repeat !important;\n  border-color: black !important;\n  border-color: currentColor !important;\n  border-radius: 0 !important;\n  border-style: none !important;\n  border-width: medium !important;\n  bottom: auto !important;\n  clear: none !important;\n  clip: auto !important;\n  color: inherit !important;\n  counter-increment: none !important;\n  counter-reset: none !important;\n  cursor: auto !important;\n  direction: inherit !important;\n  display: inline !important;\n  float: none !important;\n  font-family: inherit !important;\n  font-size: inherit !important;\n  font-style: inherit !important;\n  font-variant: normal !important;\n  font-weight: inherit !important;\n  height: auto !important;\n  left: auto !important;\n  letter-spacing: normal !important;\n  line-height: inherit !important;\n  list-style-type: inherit !important;\n  list-style-position: outside !important;\n  list-style-image: none !important;\n  margin: 0 !important;\n  max-height: none !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  opacity: 1 !important;\n  outline: invert none medium !important;\n  overflow: visible !important;\n  padding: 0 !important;\n  position: static !important;\n  quotes: "" "" !important;\n  right: auto !important;\n  table-layout: auto !important;\n  text-align: inherit !important;\n  text-decoration: inherit !important;\n  text-indent: 0 !important;\n  text-transform: none !important;\n  top: auto !important;\n  unicode-bidi: normal !important;\n  vertical-align: baseline !important;\n  visibility: inherit !important;\n  white-space: normal !important;\n  width: auto !important;\n  word-spacing: normal !important;\n  z-index: auto !important;\n  -webkit-background-origin: padding-box !important;\n  background-origin: padding-box !important;\n  -webkit-background-clip: border-box !important;\n  background-clip: border-box !important;\n  -webkit-background-size: auto !important;\n  -moz-background-size: auto !important;\n  background-size: auto !important;\n  -webkit-border-image: none !important;\n  -moz-border-image: none !important;\n  -o-border-image: none !important;\n  border-image: none !important;\n  -webkit-border-radius: 0 !important;\n  -moz-border-radius: 0 !important;\n  border-radius: 0 !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  -webkit-box-sizing: content-box !important;\n  -moz-box-sizing: content-box !important;\n  box-sizing: content-box !important;\n  -webkit-column-count: auto !important;\n  -moz-column-count: auto !important;\n  column-count: auto !important;\n  -webkit-column-gap: normal !important;\n  -moz-column-gap: normal !important;\n  column-gap: normal !important;\n  -webkit-column-rule: medium none black !important;\n  -moz-column-rule: medium none black !important;\n  column-rule: medium none black !important;\n  -webkit-column-span: 1 !important;\n  -moz-column-span: 1 !important;\n  column-span: 1 !important;\n  -webkit-column-width: auto !important;\n  -moz-column-width: auto !important;\n  column-width: auto !important;\n  font-feature-settings: normal !important;\n  overflow-x: visible !important;\n  overflow-y: visible !important;\n  -webkit-hyphens: manual !important;\n  -moz-hyphens: manual !important;\n  hyphens: manual !important;\n  -webkit-perspective: none !important;\n  -moz-perspective: none !important;\n  -ms-perspective: none !important;\n  -o-perspective: none !important;\n  perspective: none !important;\n  -webkit-perspective-origin: 50% 50% !important;\n  -moz-perspective-origin: 50% 50% !important;\n  -ms-perspective-origin: 50% 50% !important;\n  -o-perspective-origin: 50% 50% !important;\n  perspective-origin: 50% 50% !important;\n  -webkit-backface-visibility: visible !important;\n  -moz-backface-visibility: visible !important;\n  -ms-backface-visibility: visible !important;\n  -o-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  text-shadow: none !important;\n  -webkit-transition: all 0s ease 0s !important;\n  transition: all 0s ease 0s !important;\n  -webkit-transform: none !important;\n  -moz-transform: none !important;\n  -ms-transform: none !important;\n  -o-transform: none !important;\n  transform: none !important;\n  -webkit-transform-origin: 50% 50% !important;\n  -moz-transform-origin: 50% 50% !important;\n  -ms-transform-origin: 50% 50% !important;\n  -o-transform-origin: 50% 50% !important;\n  transform-origin: 50% 50% !important;\n  -webkit-transform-style: flat !important;\n  -moz-transform-style: flat !important;\n  -ms-transform-style: flat !important;\n  -o-transform-style: flat !important;\n  transform-style: flat !important;\n  word-break: normal !important;\n}\n\n.cleanslate.cleanslate,\n.cleanslate .cleanslate h3,\n.cleanslate .cleanslate h5,\n.cleanslate .cleanslate p,\n.cleanslate .cleanslate h1,\n.cleanslate .cleanslate dl,\n.cleanslate .cleanslate dt,\n.cleanslate .cleanslate h6,\n.cleanslate .cleanslate ol,\n.cleanslate .cleanslate form,\n.cleanslate .cleanslate option,\n.cleanslate .cleanslate pre,\n.cleanslate .cleanslate div,\n.cleanslate .cleanslate h2,\n.cleanslate .cleanslate caption,\n.cleanslate .cleanslate h4,\n.cleanslate .cleanslate ul,\n.cleanslate .cleanslate address,\n.cleanslate .cleanslate blockquote,\n.cleanslate .cleanslate dd,\n.cleanslate .cleanslate fieldset,\n.cleanslate .cleanslate hr,\n.cleanslate .cleanslate article,\n.cleanslate .cleanslate dialog,\n.cleanslate .cleanslate figure,\n.cleanslate .cleanslate footer,\n.cleanslate .cleanslate header,\n.cleanslate .cleanslate hgroup,\n.cleanslate .cleanslate menu,\n.cleanslate .cleanslate nav,\n.cleanslate .cleanslate section,\n.cleanslate .cleanslate audio,\n.cleanslate .cleanslate video,\n.cleanslate .cleanslate address,\n.cleanslate .cleanslate blockquote,\n.cleanslate .cleanslate colgroup,\n.cleanslate .cleanslate main,\n.cleanslate .cleanslate progress,\n.cleanslate .cleanslate summary {\n  display: block !important;\n}\n\n.cleanslate .cleanslate h1,\n.cleanslate .cleanslate h2,\n.cleanslate .cleanslate h3,\n.cleanslate .cleanslate h4,\n.cleanslate .cleanslate h5,\n.cleanslate .cleanslate h6 {\n  font-weight: bold !important;\n}\n\n.cleanslate .cleanslate h1 {\n  font-size: 2em !important;\n  padding: .67em 0 !important;\n}\n\n.cleanslate .cleanslate h2 {\n  font-size: 1.5em !important;\n  padding: .83em 0 !important;\n}\n\n.cleanslate .cleanslate h3 {\n  font-size: 1.17em !important;\n  padding: .83em 0 !important;\n}\n\n.cleanslate .cleanslate h4 {\n  font-size: 1em !important;\n}\n\n.cleanslate .cleanslate h5 {\n  font-size: .83em !important;\n}\n\n.cleanslate .cleanslate p {\n  margin: 1em 0 !important;\n}\n\n.cleanslate .cleanslate table {\n  display: table !important;\n}\n\n.cleanslate .cleanslate thead {\n  display: table-header-group !important;\n}\n\n.cleanslate .cleanslate tbody {\n  display: table-row-group !important;\n}\n\n.cleanslate .cleanslate tfoot {\n  display: table-footer-group !important;\n}\n\n.cleanslate .cleanslate tr {\n  display: table-row !important;\n}\n\n.cleanslate .cleanslate th,\n.cleanslate .cleanslate td {\n  display: table-cell !important;\n  padding: 2px !important;\n}\n\n.cleanslate .cleanslate ol,\n.cleanslate .cleanslate ul {\n  margin: 1em 0 !important;\n}\n\n.cleanslate .cleanslate ul li,\n.cleanslate .cleanslate ul ul li,\n.cleanslate .cleanslate ul ul ul li,\n.cleanslate .cleanslate ol li,\n.cleanslate .cleanslate ol ol li,\n.cleanslate .cleanslate ol ol ol li,\n.cleanslate .cleanslate ul ol ol li,\n.cleanslate .cleanslate ul ul ol li,\n.cleanslate .cleanslate ol ul ul li,\n.cleanslate .cleanslate ol ol ul li {\n  list-style-position: inside !important;\n  margin-top: .08em !important;\n}\n\n.cleanslate .cleanslate ol ol,\n.cleanslate .cleanslate ol ol ol,\n.cleanslate .cleanslate ul ul,\n.cleanslate .cleanslate ul ul ul,\n.cleanslate .cleanslate ol ul,\n.cleanslate .cleanslate ol ul ul,\n.cleanslate .cleanslate ol ol ul,\n.cleanslate .cleanslate ul ol,\n.cleanslate .cleanslate ul ol ol,\n.cleanslate .cleanslate ul ul ol {\n  padding-left: 40px !important;\n  margin: 0 !important;\n}\n\n.cleanslate .cleanslate nav ul,\n.cleanslate .cleanslate nav ol {\n  list-style-type: none !important;\n}\n\n.cleanslate .cleanslate ul,\n.cleanslate .cleanslate menu {\n  list-style-type: disc !important;\n}\n\n.cleanslate .cleanslate ol {\n  list-style-type: decimal !important;\n}\n\n.cleanslate .cleanslate ol ul,\n.cleanslate .cleanslate ul ul,\n.cleanslate .cleanslate menu ul,\n.cleanslate .cleanslate ol menu,\n.cleanslate .cleanslate ul menu,\n.cleanslate .cleanslate menu menu {\n  list-style-type: circle !important;\n}\n\n.cleanslate .cleanslate ol ol ul,\n.cleanslate .cleanslate ol ul ul,\n.cleanslate .cleanslate ol menu ul,\n.cleanslate .cleanslate ol ol menu,\n.cleanslate .cleanslate ol ul menu,\n.cleanslate .cleanslate ol menu menu,\n.cleanslate .cleanslate ul ol ul,\n.cleanslate .cleanslate ul ul ul,\n.cleanslate .cleanslate ul menu ul,\n.cleanslate .cleanslate ul ol menu,\n.cleanslate .cleanslate ul ul menu,\n.cleanslate .cleanslate ul menu menu,\n.cleanslate .cleanslate menu ol ul,\n.cleanslate .cleanslate menu ul ul,\n.cleanslate .cleanslate menu menu ul,\n.cleanslate .cleanslate menu ol menu,\n.cleanslate .cleanslate menu ul menu,\n.cleanslate .cleanslate menu menu menu {\n  list-style-type: square !important;\n}\n\n.cleanslate .cleanslate li {\n  display: list-item !important;\n  min-height: auto !important;\n  min-width: auto !important;\n  padding-left: 20px !important;\n}\n\n.cleanslate .cleanslate strong {\n  font-weight: bold !important;\n}\n\n.cleanslate .cleanslate em {\n  font-style: italic !important;\n}\n\n.cleanslate .cleanslate kbd,\n.cleanslate .cleanslate samp,\n.cleanslate .cleanslate code,\n.cleanslate .cleanslate pre {\n  font-family: monospace !important;\n}\n\n.cleanslate .cleanslate a {\n  color: blue !important;\n  text-decoration: underline !important;\n}\n\n.cleanslate .cleanslate a:visited {\n  color: #529 !important;\n}\n\n.cleanslate .cleanslate a,\n.cleanslate .cleanslate a *,\n.cleanslate .cleanslate input[type=submit],\n.cleanslate .cleanslate input[type=button],\n.cleanslate .cleanslate input[type=radio],\n.cleanslate .cleanslate input[type=checkbox],\n.cleanslate .cleanslate select,\n.cleanslate .cleanslate button {\n  cursor: pointer !important;\n}\n\n.cleanslate .cleanslate button,\n.cleanslate .cleanslate input[type=submit] {\n  text-align: center !important;\n  padding: 2px 6px 3px !important;\n  border-radius: 4px !important;\n  text-decoration: none !important;\n  font-family: arial, helvetica, sans-serif !important;\n  font-size: small !important;\n  background: white !important;\n  -webkit-appearance: push-button !important;\n  color: buttontext !important;\n  border: 1px #a6a6a6 solid !important;\n  background: lightgrey !important;\n  background: #fff !important;\n  background: -moz-linear-gradient(top, #fff 0%, #ddd 100%, #d1d1d1 100%, #ddd 100%) !important;\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fff), color-stop(100%, #ddd), color-stop(100%, #d1d1d1), color-stop(100%, #ddd)) !important;\n  background: -webkit-linear-gradient(top, #fff 0%, #ddd 100%, #d1d1d1 100%, #ddd 100%) !important;\n  background: -o-linear-gradient(top, #fff 0%, #ddd 100%, #d1d1d1 100%, #ddd 100%) !important;\n  background: -ms-linear-gradient(top, #fff 0%, #ddd 100%, #d1d1d1 100%, #ddd 100%) !important;\n  background: linear-gradient(to bottom, #fff 0%, #ddd 100%, #d1d1d1 100%, #ddd 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#ffffff\', endColorstr=\'#dddddd\',GradientType=0 ) !important;\n  -webkit-box-shadow: 1px 1px 0px #eee !important;\n  -moz-box-shadow: 1px 1px 0px #eee !important;\n  -o-box-shadow: 1px 1px 0px #eee !important;\n  box-shadow: 1px 1px 0px #eee !important;\n  outline: initial !important;\n}\n\n.cleanslate .cleanslate button:active,\n.cleanslate .cleanslate input[type=submit]:active,\n.cleanslate .cleanslate input[type=button]:active,\n.cleanslate .cleanslate button:active {\n  background: #3b679e !important;\n  background: -moz-linear-gradient(top, #3b679e 0%, #2b88d9 50%, #207cca 51%, #7db9e8 100%) !important;\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #3b679e), color-stop(50%, #2b88d9), color-stop(51%, #207cca), color-stop(100%, #7db9e8)) !important;\n  background: -webkit-linear-gradient(top, #3b679e 0%, #2b88d9 50%, #207cca 51%, #7db9e8 100%) !important;\n  background: -o-linear-gradient(top, #3b679e 0%, #2b88d9 50%, #207cca 51%, #7db9e8 100%) !important;\n  background: -ms-linear-gradient(top, #3b679e 0%, #2b88d9 50%, #207cca 51%, #7db9e8 100%) !important;\n  background: linear-gradient(to bottom, #3b679e 0%, #2b88d9 50%, #207cca 51%, #7db9e8 100%) !important;\n  border-color: #5259b0 !important;\n}\n\n.cleanslate .cleanslate button {\n  padding: 1px 6px 2px 6px !important;\n  margin-right: 5px !important;\n}\n\n.cleanslate .cleanslate input[type=hidden] {\n  display: none !important;\n}\n\n.cleanslate .cleanslate textarea {\n  -webkit-appearance: textarea !important;\n  background: white !important;\n  padding: 2px !important;\n  margin-left: 4px !important;\n  word-wrap: break-word !important;\n  white-space: pre-wrap !important;\n  font-size: 11px !important;\n  font-family: arial, helvetica, sans-serif !important;\n  line-height: 13px !important;\n  resize: both !important;\n}\n\n.cleanslate .cleanslate select,\n.cleanslate .cleanslate textarea,\n.cleanslate .cleanslate input {\n  border: 1px solid #ccc !important;\n}\n\n.cleanslate .cleanslate select {\n  font-size: 11px !important;\n  font-family: helvetica, arial, sans-serif !important;\n  display: inline-block !important;\n}\n\n.cleanslate .cleanslate textarea:focus,\n.cleanslate .cleanslate input:focus {\n  outline: auto 5px -webkit-focus-ring-color !important;\n  outline: initial !important;\n}\n\n.cleanslate .cleanslate input[type=text] {\n  background: white !important;\n  padding: 1px !important;\n  font-family: initial !important;\n  font-size: small !important;\n}\n\n.cleanslate .cleanslate input[type=checkbox],\n.cleanslate .cleanslate input[type=radio] {\n  border: 1px #2b2b2b solid !important;\n  border-radius: 4px !important;\n}\n\n.cleanslate .cleanslate input[type=checkbox],\n.cleanslate .cleanslate input[type=radio] {\n  outline: initial !important;\n}\n\n.cleanslate .cleanslate input[type=radio] {\n  margin: 2px 2px 3px 2px !important;\n}\n\n.cleanslate .cleanslate abbr[title],\n.cleanslate .cleanslate acronym[title],\n.cleanslate .cleanslate dfn[title] {\n  cursor: help !important;\n  border-bottom-width: 1px !important;\n  border-bottom-style: dotted !important;\n}\n\n.cleanslate .cleanslate ins {\n  background-color: #ff9 !important;\n  color: black !important;\n}\n\n.cleanslate .cleanslate del {\n  text-decoration: line-through !important;\n}\n\n.cleanslate .cleanslate blockquote,\n.cleanslate .cleanslate q {\n  quotes: none !important;\n}\n\n.cleanslate .cleanslate blockquote:before,\n.cleanslate .cleanslate blockquote:after,\n.cleanslate .cleanslate q:before,\n.cleanslate .cleanslate q:after,\n.cleanslate .cleanslate li:before,\n.cleanslate .cleanslate li:after {\n  content: "" !important;\n}\n\n.cleanslate .cleanslate input,\n.cleanslate .cleanslate select {\n  vertical-align: middle !important;\n}\n\n.cleanslate .cleanslate table {\n  border-collapse: collapse !important;\n  border-spacing: 0 !important;\n}\n\n.cleanslate .cleanslate hr {\n  display: block !important;\n  height: 1px !important;\n  border: 0 !important;\n  border-top: 1px solid #ccc !important;\n  margin: 1em 0 !important;\n}\n\n.cleanslate .cleanslate *[dir=rtl] {\n  direction: rtl !important;\n}\n\n.cleanslate .cleanslate mark {\n  background-color: #ff9 !important;\n  color: black !important;\n  font-style: italic !important;\n  font-weight: bold !important;\n}\n\n.cleanslate .cleanslate menu {\n  padding-left: 40px !important;\n  padding-top: 8px !important;\n}\n\n.cleanslate .cleanslate [hidden],\n.cleanslate .cleanslate template {\n  display: none !important;\n}\n\n.cleanslate .cleanslate abbr[title] {\n  border-bottom: 1px dotted !important;\n}\n\n.cleanslate .cleanslate sub,\n.cleanslate .cleanslate sup {\n  font-size: 75% !important;\n  line-height: 0 !important;\n  position: relative !important;\n  vertical-align: baseline !important;\n}\n\n.cleanslate .cleanslate sup {\n  top: -0.5em !important;\n}\n\n.cleanslate .cleanslate sub {\n  bottom: -0.25em !important;\n}\n\n.cleanslate .cleanslate img {\n  border: 0 !important;\n}\n\n.cleanslate .cleanslate figure {\n  margin: 0 !important;\n}\n\n.cleanslate .cleanslate textarea {\n  overflow: auto !important;\n  vertical-align: top !important;\n}\n\n.cleanslate.cleanslate {\n  font-size: medium !important;\n  line-height: 1 !important;\n  direction: ltr !important;\n  text-align: left !important;\n  text-align: start !important;\n  font-family: "Times New Roman", Times, serif !important;\n  color: black !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  text-decoration: none !important;\n  list-style-type: disc !important;\n}\n\n.cleanslate .cleanslate pre {\n  white-space: pre !important;\n}', ""]), e.exports = n;
}, function (e, n, t) {
  "use strict";

  t.r(n);

  var a,
      o = t(0),
      r = t(1),
      l = t.n(r),
      i = (t(6), t(8)),
      c = function c(e) {
    var n = e.art,
        t = e.href,
        a = e.header,
        r = e.blurb;
    return o.default.createElement("div", {
      className: "product-outer"
    }, n, o.default.createElement("div", {
      className: "product-inner"
    }, a, r), o.default.createElement("a", {
      href: t,
      target: "_blank",
      rel: "noopener noreferrer"
    }, o.default.createElement(l.a, {
      src: i,
      className: "product-link"
    })));
  };

  !function (e) {
    e[e.CMIX = 0] = "CMIX", e[e.SAMPLIFY = 1] = "SAMPLIFY", e[e.MARKET_SIGHT = 2] = "MARKET_SIGHT", e[e.INSTANT_INSIGHTS = 3] = "INSTANT_INSIGHTS";
  }(a || (a = {}));
  t(9);

  var s,
      u = t(11),
      p = t(12),
      d = t(13),
      f = t(14),
      m = new Map([[a.CMIX, {
    header: o.default.createElement("h1", null, "Scripting with Cmix"),
    blurb: o.default.createElement("p", null, "Enables researchers and marketers to build comprehensive surveys for all their research, marketing, and CRM needs."),
    art: o.default.createElement(l.a, {
      className: "product-icon",
      src: u
    })
  }], [a.INSTANT_INSIGHTS, {
    header: o.default.createElement("h1", null, "Instant Insights"),
    blurb: o.default.createElement("p", null, "Simple, quick turnaround, single question survey to inform your Instincts with real time insights!"),
    art: o.default.createElement(l.a, {
      className: "product-icon",
      src: f
    })
  }], [a.MARKET_SIGHT, {
    header: o.default.createElement("h1", null, "Reporting and Analytics with MarketSight"),
    blurb: o.default.createElement("p", null, "Analyze, visualize, and share insights from survey data at your fingertips."),
    art: o.default.createElement(l.a, {
      className: "product-icon",
      src: d
    })
  }], [a.SAMPLIFY, {
    header: o.default.createElement("h1", null, "Sampling with Samplify"),
    blurb: o.default.createElement("p", null, "Provides access to millions of deeply profiled consumers with on-demand, easy-to-use research tools."),
    art: o.default.createElement(l.a, {
      className: "product-icon",
      src: p
    })
  }]]),
      h = function h(e) {
    var n = e.appLinks,
        t = Array.from(n.keys()).sort();
    return o.default.createElement("div", {
      className: "product-list"
    }, t.map(function (e) {
      var t = e,
          a = m.get(t),
          r = a.header,
          l = a.blurb,
          i = a.art;
      return o.default.createElement(c, {
        key: e,
        header: r,
        blurb: l,
        art: i,
        href: n.get(t)
      });
    }));
  };

  !function (e) {
    e.CMIX = "CMIX", e.SAMPLIFY = "SAMPLIFY", e.MARKET_SIGHT = "MARKET_SIGHT", e.INSTANT_INSIGHTS = "INSTANT_INSIGHTS";
  }(s || (s = {}));

  var _,
      v = s,
      g = {
    DEV: {
      SAMPLIFY: "https://samplify.dev.pe.dynata.com",
      CMIX: "https://kaleidoscope-auth.cmix.com/dynata-platform",
      MARKET_SIGHT: "https://sandbox.marketsight.com/platform-uat-api/v1/navigate?partner=SJSUlYgLFkelvqrnAX9HbA",
      INSTANT_INSIGHTS: "https://instant-insights.dev.pe.dynata.com"
    },
    UAT: {
      SAMPLIFY: "https://samplify.uat.pe.dynata.com",
      CMIX: "https://keycloak.uat.pe.dynata.com/auth/realms/pe/protocol/openid-connect/auth?scope=openid&response_type=code&client_id=dynataplatform&redirect_uri=https%3A%2F%2Fkaleidoscope-auth.cmix.com%2Fdynata-platform",
      MARKET_SIGHT: "https://keycloak.uat.pe.dynata.com/auth/realms/pe/protocol/openid-connect/auth?scope=openid&response_type=code&client_id=dynataplatform&redirect_uri=https://sandbox.marketsight.com/platform-uat-api/v1/navigate?partner=SJSUlYgLFkelvqrnAX9HbA",
      INSTANT_INSIGHTS: "https://instant-insights.uat.pe.dynata.com"
    },
    PROD: {
      SAMPLIFY: "https://samplify.dynata.com",
      CMIX: "https://login.dynata.com/auth/realms/pe/protocol/openid-connect/auth?scope=openid&response_type=code&client_id=dynataplatform&redirect_uri=https%3A%2F%2Fauth.cmix.com%2Fdynata-platform",
      MARKET_SIGHT: "https://login.dynata.com/auth/realms/pe/protocol/openid-connect/auth?scope=openid&response_type=code&client_id=dynataplatform&redirect_uri=https://application.marketsight.com/api/v1/navigate?partner=UV6sjW8ETEaesqsMAPkvbw",
      INSTANT_INSIGHTS: "https://instant-insights.dynata.com"
    }
  };

  t(15);
  !function (e) {
    e.DEV = "DEV", e.UAT = "UAT", e.PROD = "PROD";
  }(_ || (_ = {}));

  var y = function y(e, n) {
    var t = n.map(function (e) {
      return e.toUpperCase();
    }),
        o = new Set(t),
        r = new Map(),
        l = function (e) {
      switch (e) {
        case _.PROD:
          return g.PROD;

        case _.UAT:
          return g.UAT;

        case _.DEV:
        default:
          return g.DEV;
      }
    }(e);

    return o.has(v.CMIX) && r.set(a.CMIX, l.CMIX), o.has(v.SAMPLIFY) && r.set(a.SAMPLIFY, l.SAMPLIFY), o.has(v.MARKET_SIGHT) && r.set(a.MARKET_SIGHT, l.MARKET_SIGHT), o.has(v.INSTANT_INSIGHTS) && r.set(a.INSTANT_INSIGHTS, l.INSTANT_INSIGHTS), r;
  },
      b = function b(e) {
    var n = e.open,
        t = e.env,
        a = e.apps;
    if (!n) return null;
    var r = y(t, a);
    return o.default.createElement("div", {
      className: "docked-widget"
    }, o.default.createElement("div", {
      className: "launcher-outer"
    }, o.default.createElement("div", {
      className: "launcher-container"
    }, o.default.createElement(h, {
      appLinks: r
    }))));
  };

  t(17);

  function C(e, n) {
    if (null == e) return {};

    var t,
        a,
        o = function (e, n) {
      if (null == e) return {};
      var t,
          a,
          o = {},
          r = Object.keys(e);

      for (a = 0; a < r.length; a++) {
        t = r[a], n.indexOf(t) >= 0 || (o[t] = e[t]);
      }

      return o;
    }(e, n);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);

      for (a = 0; a < r.length; a++) {
        t = r[a], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
      }
    }

    return o;
  }

  function L(e, n) {
    for (var t = 0; t < n.length; t++) {
      var a = n[t];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }

  function k(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  t.d(n, "default", function () {
    return x;
  });

  var x = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    var n, t, a;
    return n = e, a = [{
      key: "mount",
      value: function value() {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = n.parentElement,
            a = void 0 === t ? null : t,
            r = C(n, ["parentElement"]),
            l = r.apps || [],
            i = r.env || "DEV",
            c = void 0 !== r.open && r.open;
        e.open = c;
        var s = o.default.createElement(b, {
          apps: l,
          env: i,
          open: c
        });

        function u() {
          if (e.el) throw new Error("DIPLauncherWidget is already mounted, unmount first");
          var n = document.createElement("div");
          n.setAttribute("class", "cleanslate"), "string" == typeof a ? document.querySelector(a).appendChild(n) : null !== a ? a.appendChild(n) : document.body.appendChild(n), o.default.render(s, n), e.el = n;
        }

        "complete" === document.readyState ? u() : window.addEventListener("load", function () {
          u();
        });
      }
    }, {
      key: "render",
      value: function value(n) {
        var t = n.apps || [],
            a = n.env || "DEV";
        void 0 !== n.open && (e.open = n.open);
        var r = o.default.createElement(b, {
          apps: t,
          env: a,
          open: e.open
        });
        o.default.render(r, e.el);
      }
    }, {
      key: "unmount",
      value: function value() {
        if (!e.el) throw new Error("DIPLauncherWidget is not mounted, mount first");
        o.default.unmountComponentAtNode(e.el), e.el.parentNode.removeChild(e.el), e.el = null;
      }
    }], (t = null) && L(n.prototype, t), a && L(n, a), e;
  }();

  k(x, "el", void 0), k(x, "open", !1);
}, function (e, n, t) {
  "use strict";

  t.r(n);

  var a = t(0),
      o = function o(e, n) {
    var t = "function" == typeof Symbol && e[Symbol.iterator];
    if (!t) return e;
    var a,
        o,
        r = t.call(e),
        l = [];

    try {
      for (; (void 0 === n || n-- > 0) && !(a = r.next()).done;) {
        l.push(a.value);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        a && !a.done && (t = r.return) && t.call(r);
      } finally {
        if (o) throw o.error;
      }
    }

    return l;
  },
      r = ["br", "col", "colgroup", "dl", "hr", "iframe", "img", "input", "link", "menuitem", "meta", "ol", "param", "select", "table", "tbody", "tfoot", "thead", "tr", "ul", "wbr"],
      l = {
    "accept-charset": "acceptCharset",
    acceptcharset: "acceptCharset",
    accesskey: "accessKey",
    allowfullscreen: "allowFullScreen",
    autocapitalize: "autoCapitalize",
    autocomplete: "autoComplete",
    autocorrect: "autoCorrect",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    autosave: "autoSave",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    class: "className",
    classid: "classID",
    classname: "className",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    controlslist: "controlsList",
    crossorigin: "crossOrigin",
    dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
    datetime: "dateTime",
    defaultchecked: "defaultChecked",
    defaultvalue: "defaultValue",
    enctype: "encType",
    for: "htmlFor",
    formmethod: "formMethod",
    formaction: "formAction",
    formenctype: "formEncType",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    htmlfor: "htmlFor",
    httpequiv: "httpEquiv",
    "http-equiv": "httpEquiv",
    icon: "icon",
    innerhtml: "innerHTML",
    inputmode: "inputMode",
    itemid: "itemID",
    itemprop: "itemProp",
    itemref: "itemRef",
    itemscope: "itemScope",
    itemtype: "itemType",
    keyparams: "keyParams",
    keytype: "keyType",
    marginwidth: "marginWidth",
    marginheight: "marginHeight",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    nomodule: "noModule",
    novalidate: "noValidate",
    playsinline: "playsInline",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    referrerpolicy: "referrerPolicy",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap",
    accentheight: "accentHeight",
    "accent-height": "accentHeight",
    alignmentbaseline: "alignmentBaseline",
    "alignment-baseline": "alignmentBaseline",
    allowreorder: "allowReorder",
    arabicform: "arabicForm",
    "arabic-form": "arabicForm",
    attributename: "attributeName",
    attributetype: "attributeType",
    autoreverse: "autoReverse",
    basefrequency: "baseFrequency",
    baselineshift: "baselineShift",
    "baseline-shift": "baselineShift",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    capheight: "capHeight",
    "cap-height": "capHeight",
    clippath: "clipPath",
    "clip-path": "clipPath",
    clippathunits: "clipPathUnits",
    cliprule: "clipRule",
    "clip-rule": "clipRule",
    colorinterpolation: "colorInterpolation",
    "color-interpolation": "colorInterpolation",
    colorinterpolationfilters: "colorInterpolationFilters",
    "color-interpolation-filters": "colorInterpolationFilters",
    colorprofile: "colorProfile",
    "color-profile": "colorProfile",
    colorrendering: "colorRendering",
    "color-rendering": "colorRendering",
    contentscripttype: "contentScriptType",
    contentstyletype: "contentStyleType",
    diffuseconstant: "diffuseConstant",
    dominantbaseline: "dominantBaseline",
    "dominant-baseline": "dominantBaseline",
    edgemode: "edgeMode",
    enablebackground: "enableBackground",
    "enable-background": "enableBackground",
    externalresourcesrequired: "externalResourcesRequired",
    fillopacity: "fillOpacity",
    "fill-opacity": "fillOpacity",
    fillrule: "fillRule",
    "fill-rule": "fillRule",
    filterres: "filterRes",
    filterunits: "filterUnits",
    floodopacity: "floodOpacity",
    "flood-opacity": "floodOpacity",
    floodcolor: "floodColor",
    "flood-color": "floodColor",
    fontfamily: "fontFamily",
    "font-family": "fontFamily",
    fontsize: "fontSize",
    "font-size": "fontSize",
    fontsizeadjust: "fontSizeAdjust",
    "font-size-adjust": "fontSizeAdjust",
    fontstretch: "fontStretch",
    "font-stretch": "fontStretch",
    fontstyle: "fontStyle",
    "font-style": "fontStyle",
    fontvariant: "fontVariant",
    "font-variant": "fontVariant",
    fontweight: "fontWeight",
    "font-weight": "fontWeight",
    glyphname: "glyphName",
    "glyph-name": "glyphName",
    glyphorientationhorizontal: "glyphOrientationHorizontal",
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphorientationvertical: "glyphOrientationVertical",
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    horizadvx: "horizAdvX",
    "horiz-adv-x": "horizAdvX",
    horizoriginx: "horizOriginX",
    "horiz-origin-x": "horizOriginX",
    imagerendering: "imageRendering",
    "image-rendering": "imageRendering",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    letterspacing: "letterSpacing",
    "letter-spacing": "letterSpacing",
    lightingcolor: "lightingColor",
    "lighting-color": "lightingColor",
    limitingconeangle: "limitingConeAngle",
    markerend: "markerEnd",
    "marker-end": "markerEnd",
    markerheight: "markerHeight",
    markermid: "markerMid",
    "marker-mid": "markerMid",
    markerstart: "markerStart",
    "marker-start": "markerStart",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    overlineposition: "overlinePosition",
    "overline-position": "overlinePosition",
    overlinethickness: "overlineThickness",
    "overline-thickness": "overlineThickness",
    paintorder: "paintOrder",
    "paint-order": "paintOrder",
    "panose-1": "panose1",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointerevents: "pointerEvents",
    "pointer-events": "pointerEvents",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    renderingintent: "renderingIntent",
    "rendering-intent": "renderingIntent",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    shaperendering: "shapeRendering",
    "shape-rendering": "shapeRendering",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    stopcolor: "stopColor",
    "stop-color": "stopColor",
    stopopacity: "stopOpacity",
    "stop-opacity": "stopOpacity",
    strikethroughposition: "strikethroughPosition",
    "strikethrough-position": "strikethroughPosition",
    strikethroughthickness: "strikethroughThickness",
    "strikethrough-thickness": "strikethroughThickness",
    strokedasharray: "strokeDasharray",
    "stroke-dasharray": "strokeDasharray",
    strokedashoffset: "strokeDashoffset",
    "stroke-dashoffset": "strokeDashoffset",
    strokelinecap: "strokeLinecap",
    "stroke-linecap": "strokeLinecap",
    strokelinejoin: "strokeLinejoin",
    "stroke-linejoin": "strokeLinejoin",
    strokemiterlimit: "strokeMiterlimit",
    "stroke-miterlimit": "strokeMiterlimit",
    strokewidth: "strokeWidth",
    "stroke-width": "strokeWidth",
    strokeopacity: "strokeOpacity",
    "stroke-opacity": "strokeOpacity",
    suppresscontenteditablewarning: "suppressContentEditableWarning",
    suppresshydrationwarning: "suppressHydrationWarning",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textanchor: "textAnchor",
    "text-anchor": "textAnchor",
    textdecoration: "textDecoration",
    "text-decoration": "textDecoration",
    textlength: "textLength",
    textrendering: "textRendering",
    "text-rendering": "textRendering",
    underlineposition: "underlinePosition",
    "underline-position": "underlinePosition",
    underlinethickness: "underlineThickness",
    "underline-thickness": "underlineThickness",
    unicodebidi: "unicodeBidi",
    "unicode-bidi": "unicodeBidi",
    unicoderange: "unicodeRange",
    "unicode-range": "unicodeRange",
    unitsperem: "unitsPerEm",
    "units-per-em": "unitsPerEm",
    unselectable: "unselectable",
    valphabetic: "vAlphabetic",
    "v-alphabetic": "vAlphabetic",
    vectoreffect: "vectorEffect",
    "vector-effect": "vectorEffect",
    vertadvy: "vertAdvY",
    "vert-adv-y": "vertAdvY",
    vertoriginx: "vertOriginX",
    "vert-origin-x": "vertOriginX",
    vertoriginy: "vertOriginY",
    "vert-origin-y": "vertOriginY",
    vhanging: "vHanging",
    "v-hanging": "vHanging",
    videographic: "vIdeographic",
    "v-ideographic": "vIdeographic",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    vmathematical: "vMathematical",
    "v-mathematical": "vMathematical",
    wordspacing: "wordSpacing",
    "word-spacing": "wordSpacing",
    writingmode: "writingMode",
    "writing-mode": "writingMode",
    xchannelselector: "xChannelSelector",
    xheight: "xHeight",
    "x-height": "xHeight",
    xlinkactuate: "xlinkActuate",
    "xlink:actuate": "xlinkActuate",
    xlinkarcrole: "xlinkArcrole",
    "xlink:arcrole": "xlinkArcrole",
    xlinkhref: "xlinkHref",
    "xlink:href": "xlinkHref",
    xlinkrole: "xlinkRole",
    "xlink:role": "xlinkRole",
    xlinkshow: "xlinkShow",
    "xlink:show": "xlinkShow",
    xlinktitle: "xlinkTitle",
    "xlink:title": "xlinkTitle",
    xlinktype: "xlinkType",
    "xlink:type": "xlinkType",
    xmlbase: "xmlBase",
    "xml:base": "xmlBase",
    xmllang: "xmlLang",
    "xml:lang": "xmlLang",
    "xml:space": "xmlSpace",
    xmlnsxlink: "xmlnsXlink",
    "xmlns:xlink": "xmlnsXlink",
    xmlspace: "xmlSpace",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan",
    onblur: "onBlur",
    onchange: "onChange",
    onclick: "onClick",
    oncontextmenu: "onContextMenu",
    ondoubleclick: "onDoubleClick",
    ondrag: "onDrag",
    ondragend: "onDragEnd",
    ondragenter: "onDragEnter",
    ondragexit: "onDragExit",
    ondragleave: "onDragLeave",
    ondragover: "onDragOver",
    ondragstart: "onDragStart",
    ondrop: "onDrop",
    onerror: "onError",
    onfocus: "onFocus",
    oninput: "onInput",
    oninvalid: "onInvalid",
    onkeydown: "onKeyDown",
    onkeypress: "onKeyPress",
    onkeyup: "onKeyUp",
    onload: "onLoad",
    onmousedown: "onMouseDown",
    onmouseenter: "onMouseEnter",
    onmouseleave: "onMouseLeave",
    onmousemove: "onMouseMove",
    onmouseout: "onMouseOut",
    onmouseover: "onMouseOver",
    onmouseup: "onMouseUp",
    onscroll: "onScroll",
    onsubmit: "onSubmit",
    ontouchcancel: "onTouchCancel",
    ontouchend: "onTouchEnd",
    ontouchmove: "onTouchMove",
    ontouchstart: "onTouchStart",
    onwheel: "onWheel"
  };

  t.d(n, "convertFromNode", function () {
    return p;
  }), t.d(n, "convertFromString", function () {
    return d;
  }), t.d(n, "default", function () {
    return f;
  });

  var _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var n, t = 1, a = arguments.length; t < a; t++) {
        for (var o in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      c = function c(e, n) {
    var t = "function" == typeof Symbol && e[Symbol.iterator];
    if (!t) return e;
    var a,
        o,
        r = t.call(e),
        l = [];

    try {
      for (; (void 0 === n || n-- > 0) && !(a = r.next()).done;) {
        l.push(a.value);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        a && !a.done && (t = r.return) && t.call(r);
      } finally {
        if (o) throw o.error;
      }
    }

    return l;
  },
      s = function s() {
    for (var e = [], n = 0; n < arguments.length; n++) {
      e = e.concat(c(arguments[n]));
    }

    return e;
  };

  function u(e, n) {
    var t = {
      key: n
    };

    if (e instanceof Element) {
      var a = e.getAttribute("class");
      a && (t.className = a), s(e.attributes).forEach(function (e) {
        switch (e.name) {
          case "class":
            break;

          case "style":
            t[e.name] = e.value.split(/ ?; ?/).reduce(function (e, n) {
              var t = o(n.split(/ ?: ?/), 2),
                  a = t[0],
                  r = t[1];
              return a && r && (e[a.replace(/-(\w)/g, function (e, n) {
                return n.toUpperCase();
              })] = Number.isNaN(Number(r)) ? r : Number(r)), e;
            }, {});
            break;

          case "checked":
          case "disabled":
          case "selected":
          case "autoplay":
          case "controls":
            t[e.name] = e.name;
            break;

          default:
            t[l[e.name] || e.name] = e.value;
        }
      });
    }

    return t;
  }

  function p(e, n) {
    if (void 0 === n && (n = {}), !(e && e instanceof Node)) return null;

    var t,
        o = n.actions,
        l = void 0 === o ? [] : o,
        c = n.index,
        d = void 0 === c ? 0 : c,
        f = n.level,
        m = void 0 === f ? 0 : f,
        h = e,
        _ = m + "-" + d,
        v = [];

    if (Array.isArray(l) && l.forEach(function (n) {
      n.condition(h, _, m) && ("function" == typeof n.pre && ((h = n.pre(h, _, m)) instanceof Node || (h = e)), "function" == typeof n.post && v.push(n.post(h, _, m)));
    }), v.length) return v;

    switch (h.nodeType) {
      case 1:
        return a.createElement((t = h.nodeName, /[a-z]+[A-Z]+[a-z]+/.test(t) ? t : t.toLowerCase()), u(h, _), function (e, n, t) {
          var a = s(e).map(function (e, a) {
            return p(e, _i(_i({}, t), {
              index: a,
              level: n + 1
            }));
          }).filter(Boolean);
          return a.length ? a : null;
        }(h.childNodes, m, n));

      case 3:
        var g = h.nodeValue.toString();
        if (/^\s+$/.test(g)) return null;
        if (!h.parentNode) return g;
        var y = h.parentNode.nodeName.toLowerCase();
        return -1 !== r.indexOf(y) ? (/\S/.test(g) && console.warn("A textNode is not allowed inside '" + y + "'. Your text \"" + g + '" will be ignored'), null) : g;

      case 8:
      default:
        return null;
    }
  }

  function d(e, n) {
    if (void 0 === n && (n = {}), !e || "string" != typeof e) return null;
    var t = n.nodeOnly,
        a = void 0 !== t && t,
        o = n.selector,
        r = void 0 === o ? "body > *" : o,
        l = n.type,
        i = void 0 === l ? "text/html" : l;

    try {
      var c = new DOMParser().parseFromString(e, i).querySelector(r);
      if (!(c instanceof Node)) throw new Error("Error parsing input");
      return a ? c : p(c, n);
    } catch (e) {
      0;
    }

    return null;
  }

  function f(e, n) {
    return void 0 === n && (n = {}), "string" == typeof e ? d(e, n) : e instanceof Node ? p(e, n) : null;
  }
}]).default;